<template>
  <div id="LiveHotel">
    <!--数据加载倒计时-->
    <launch v-show="!loading" @closeload="closeload" :loaded="loaded"></launch>
    <tipsView
      v-if="isBlack"
      message="你无权观看此直播，请联系管理员"
    ></tipsView>
    <tipsView
      v-if="isyxinImLoginOut"
      message="你在其他端登陆，刷新后可以重新登陆!"
    ></tipsView>
    <!--登记观看-->
    <!-- <RegisterView
      @registerOk="registerOk"
      :fans_id="fans_id"
      :ds_id="ds_id"
      v-if="registerViewShow"
      @closeload="registerViewClose"
    ></RegisterView> -->
    <!-- 白名单观看 -->
    <TelTest
      style="z-index:9900"
      @whiteNumOk="whiteNumOk"
      :fans_id="fans_id"
      :ds_id="ds_id"
      :show_type="show_type"
      :need_check_bool="need_check_bool"
      v-if="TelTestShow"
    ></TelTest>
    <!-- 门票观看 -->
    <!-- <payWatch></payWatch> -->
    <!--头部标题模块-->
    <div
      class="headtitle"
      v-show="showhead"
      :style="'background:' + headtitleBg"
    >
      <p class="ellipsis">{{ titleName }}</p>
    </div>
    <!--顶部广告位-->
    <!-- <topAd v-if="topAD" :topObj="topObj" @closeAD="closeAD"></topAd> -->
    <!-- <div class="videoMusk" v-if="fullscr && isIOS"></div> -->
    <!-- <div
      class="showTeacherBtnTop"
      @click="showTeacherBtnTopClicked"
      v-if="isShowTeacherBtnTop"
    >
      <img
        src="https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/rad_heart.png"
      />
    </div> -->
    <!--视频模块-->
    <div class="player SPZBPlayer" v-if="!isBlack">
      <TFPlayer
        ref="tfPlayer"
        :initData="initData"
        :fans_id="fans_id"
        :videoIndex="videoIndex"
        :selectPlayType="selectPlayType"
        @statusChange="playerStatusChange"
        @linkTypeChange="linkTypeChange"
        @isSupportRTC="isSupportRTCCallBack"
        @unAutoPlay="unAutoPlay"
        @playFailed="playFailed"
        @playerListener="playerListener"
        :runObj="runObj"
        :copyrightObj="copyrightObj"
      />
    </div>
    <div class="player" v-else>
      <img
        style="width:100%;height:100%;"
        :src="initData && initData.direct_seeding.pic_url"
      />
    </div>
    <!--视频浮动工具栏-->
    <div class="floatBox" :style="'margin-top:' + playHeight + 'px'">
      <!-- 试看 -->
      <div
        class="trySee"
        v-if="isTrySee && (directStatus == 'end' || videoIndex != 0) && !is_pay"
        :style="'opacity:' + tryOpacity"
      >
        试看{{ tryTime }}秒，付费观看完整版
      </div>
      <div
        class="tryPay"
        v-if="isTrySee && (directStatus == 'end' || videoIndex != 0) && !is_pay"
        v-show="tryPayBtn && !fullscr"
        @click="onShowPay"
        :style="'margin-top:' + barHeight + 'px'"
      >
        付费
      </div>

      <!--跑马灯-->
      <!-- <div
        class="scrollbar"
        :style="'margin-top:' + marqueeheight + 'px' + marqueeStyle"
        v-if="openRolling"
        v-show="isRolling"
      >
        <p v-dompurify-html="MerryGoRound"></p>
      </div> -->

      <!--观看人数-->
      <span
        class="view_num"
        :style="'margin-top:' + barHeight + 'px'"
        v-show="hot && noClearScreen"
      >
        <img
          style="margin-top: -5px"
          src="https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/hot_num.png"
        />
        <template v-if="view_num > 10000"
          >{{ parseInt(view_num / 100) / 100 }}万</template
        >
        <template v-else>{{ view_num }}</template>
      </span>

      <!--关闭飘窗 !fullscr&&isShowControl -->
      <div class="window" @click="swichWindow" v-show="false">
        <img v-if="forbid" :src="imgPath + 'room/fly-g.png'" />
        <img v-else :src="imgPath + 'room/fly-w.png'" />
      </div>

      <!--播放音乐-->
      <!-- <div
        @click="setMusic"
        class="music"
        :style="'margin-top:' + barHeight + 'px'"
        v-if="musicStatusexist"
        v-show="musicStatus"
        id="music"
        :class="{ musicPlay: musicPlay }"
      >
        <img v-if="musicPlay" :src="imgPath + 'home/music.png'" />
        <img v-else :src="imgPath + 'home/music1.png'" />
        <audio autoplay="autoplay" id="audio" :src="musicUrl"></audio>
      </div> -->

      <!-- 邀请得分销奖励 -->
      <div
        class="allot_btn"
        @click="onShowAllot"
        v-if="allot_sale"
        v-show="!isPlayUI"
      >
        <span>邀</span>
        <span>邀请好友</span>
      </div>

      <!--分享得奖励-->
      <span
        id="shareRed"
        class="shareRed"
        v-if="shareRedexist"
        v-show="shareRed"
      >
        分享得
        <template v-if="shareType == 0">红包</template>
        <template v-else>卡券</template>
      </span>
    </div>

    <!-- 聊天 -->
    <chatlist v-show="noClearScreen" ref="chat" :noticeObj="noticeObj" :ds_id="ds_id"></chatlist>


    <!--三个工具栏-->
    <template>
      <!--底部工具栏-->
      <toolBar v-show="noClearScreen" :uid="uid" :channel_id="channel_id" :verify_comment="verify_comment" :fans_id="fans_id" :say_self="say_self" :isshowgift="isshowgift"   @comment="onReceivedMsgCallBack"></toolBar>
      <!-- <ConsultTeacher
        v-show="showConsultTeacher"
        ref="consultTeacher"
        :dsId="ds_id"
        :fansId="fans_id"
        :tid="tid"
        @closeBtnClicked="consultTeacherCloseBtnClicked"
      /> -->
      <goodsList
        v-show="showGoods"
        ref="goodsList"
        :dsId="ds_id"
        :fansId="fans_id"
        :tid="tid"
        :gid="gid"
        :uid="uid"
        :channel_id="channel_id"
        :goodsIds="goodsIdsList"
        @closeBtnClicked="goodsListCloseBtnClicked"
      />
    </template>
    
    <div class="rightFunction">
      <div class="rightfuncImage" v-if="noClearScreen && (businessConfigs && (businessConfigs.student_room_link_mic_show || businessConfigs.student_room_link_mic_show == undefined))
        && initData && initData.direct_seeding.direct_status == 'running' && playerStatus == 2">
        <img style="margin-top: -12px" @click="sendApplyLink" v-if="linkType != 3" src="../../../../statics/imgs/lianmai.png" />
        <img style="margin-top: -12px" @click="sendEndLink" v-if="linkType == 3" src="../../../../statics/imgs/lianmaizhong.png" />
        <!-- <span class="functiontitle">{{ linkType == 3 ? '连麦中' : '连麦' }}</span> -->
      </div>
       <img v-if="isshowCart == true" class="rightfuncImage" @click="onShowGoodsList" style="margin-bottom:10px;" src="../../../../statics/imgs/cart-Empty.png"/>
       <img  class="rightfuncImage" style="margin-bottom:10px;" @click="noClearScreen=!noClearScreen"  src="https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_clear.png" />
       <img  class="rightfuncImage" v-show="noClearScreen" @click="showLiveWay=true"  src="https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_qiehuan.png" />
    </div>

    <div
      v-if="isShowLoginErr"
      :style="loginErrroStyle"
      style="position: fixed;bottom: 0;left: 0;right: 0;z-index: 1911;background: rgba(0, 0, 0, 0.84);"
    >
      <van-button
        type="danger"
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
        @click="tryLogin"
        >重新登录</van-button
      >
    </div>

    <!--微信二维码-->
    <div class="weixincode">
      <van-popup
        v-model="isShowQRimg"
        :close-on-click-overlay="true"
        class="codebox"
      >
        <div class="popup">
          <span class="focus-on-click"></span>
          <div class="popup-head">
            <div class="pp-title-top">
              <img
                src="https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/title-popup.png"
              />
              <h3 class="popup-title">
                <strong
                  class="balanced"
                  style="font-size: 15px; font-weight: bold; color: #353535"
                  >{{ weixintopText }}</strong
                >
              </h3>
              <img
                src="https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/title-popup.png"
              />
            </div>
          </div>
          <div class="popup-body">
            <img
              :src="weixincodeUrl"
              style="max-width: 100%; max-height: 130px"
            />
            <p
              style="
                text-align: center;
                color: #353535;
                font-size: 13px;
                margin-top: 10px;
              "
            >
              - {{ weixinbottomText }} -
            </p>
          </div>
          <div class="popup-end" @click="isShowQRimg = false">关闭</div>
        </div>
      </van-popup>
      <van-popup
        v-model="showLiveWay"
        :close-on-click-overlay="true"
        class="codebox"
      >
        <div class="popup">
          <span class="focus-on-click"></span>
          <div class="popup-body live-way">
            <p>
              <van-button
                v-if="selectPlayType == 2"
                @click="changePlayType(2)"
                type="primary"
                >普通直播</van-button
              >
              <van-button v-else @click="changePlayType(2)"
                >普通直播</van-button
              >
            </p>
            <!-- <p v-show="!tid">
              <van-button
                v-if="selectPlayType == 1"
                @click="changePlayType(1)"
                type="primary"
                >低延迟线路一</van-button
              >
              <van-button v-else @click="changePlayType(1)"
                >低延迟线路一</van-button
              >
            </p> -->
            <p>
              <van-button
                v-if="selectPlayType == 3"
                @click="changePlayType(3)"
                type="primary"
                >低延迟线路一</van-button
              >
              <van-button v-else @click="changePlayType(3)"
                >低延迟线路一</van-button
              >
            </p>
          </div>
          <div class="popup-end" @click="showLiveWay = false">关闭</div>
        </div>
      </van-popup>

      <!-- 老师二维码 -->
      <van-popup
        v-model="isShowTeacherQrCode"
        :close-on-click-overlay="false"
        class="codebox"
      >
        <div class="popup">
          <span class="focus-on-click"></span>
          <div class="popup-head">
            <!-- <van-icon class="boxCloseBtn" @click="showTeacherQrCodeCliced" name="close" /> -->
            <div class="pp-title-top">
              <h3 class="popup-title">
                <strong
                  class="balanced"
                  style="font-size: 15px; font-weight: bold; color: #353535"
                  >{{ teacher_qrcode_title }}</strong
                >
              </h3>
            </div>
          </div>
          <div class="popup-body">
            <img
              :src="teacher_qrcode_url"
              style="max-width: 100%; max-height:375px"
            />
          </div>
          <div class="popup-end" @click="showTeacherQrCodeCliced">关闭</div>
        </div>
      </van-popup>
      <!-- QQ登录 -->
      <van-popup
        v-model="showQQPopUp"
        :close-on-click-overlay="false"
        class="qqLogin"
        :style="{ width: '70%' }"
        :overlay-style="{ zIndex: '2001' }"
      >
        <div class="loginWay">
          <div class="qqtitle">QQ授权登录</div>
          <div class="qqBox" @click="qqloginTap">
            <img
              class="qqlogoImg"
              src="https://res-live.tenghuiwangxiao.cn/web/wx-user/img/QQ1.png"
            />
            <div style="padding-top:10px;">点击登录</div>
          </div>
        </div>
      </van-popup>
      <!-- QQ登录 -->
      <!-- <van-popup
        v-model="showWxPopUp"
        :close-on-click-overlay="false"
        class="qqLogin"
        :style="{ width: '70%' }"
        :overlay-style="{ zIndex: '2001' }"
      >
        <div class="loginWay">
          <div class="qqtitle">微信授权登录即可查看详情</div>
          <div class="qqBox">
             <van-button @click="wxloginTap" style="padding:0px 45px;" round type="primary">确认登录</van-button>
            <div @click="closeWindow" style="padding-top:30px;color:#c9c9c9;">取消</div>
          </div>
        </div>
      </van-popup> -->
      <!-- 网校账号密码登录 -->
      <van-popup
        v-model="showLineSchoolPopUp"
        :close-on-click-overlay="false"
        class="onlineSchoolLogin"
        :style="{ width: '100%' }"
        :overlay-style="{ zIndex: '2001' }"
      >
        <div class="onlineSchoolLoginWay">
          <div class="title">网校账号登录</div>
          <div class="desc">此课程为VIP课程，需要登录后观看</div>
          <div class="loginContent">
            <div class="account">
              <span class="area">+86</span>
              <input
                v-model="onlineSchoolAccount"
                class="loginInput"
                placeholder="请输入手机号码"
              />
            </div>
            <div class="account" v-if="loginType == 1">
              <input
                v-model="onlineSchoolPassword"
                type="password"
                class="loginInput"
                placeholder="请输入密码"
              />
            </div>
            <div class="password" v-else>
              <input
                v-model="onLIneSchoolSMSCode"
                class="loginInput passwordInput"
                placeholder="请输入验证码"
              />
              <van-button
                class="sendBtn"
                size="small"
                :disabled="onlineSendMsgNum != 0"
                @click="onlineLineSchoolSendMsg"
                type="primary"
                >{{ onlineSednMsgText }}</van-button
              >
            </div>
            <van-button
              v-if="loginType == 1"
              @click="onlineSchoolPWDLoginClick"
              class="loginOnlineBtn"
              type="primary"
              size="small"
              >网校登录</van-button
            >
            <van-button
              v-else
              @click="onlineSchoolLoginClick"
              class="loginOnlineBtn"
              type="primary"
              size="small"
              >网校登录</van-button
            >

            <div style="margin-top:30px;">
              <span
                @click="loginType == 1 ? (loginType = 2) : (loginType = 1)"
                style="color: #10a675;margin-left: 30px;"
                >{{ loginType == 1 ? "验证码登录" : "账号密码登录" }}</span
              >
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <LinkPopup
      :isShow="linkDialogVisible"
      :linkType="linkType"
      @accept="linkAccept"
      @refuse="linkRefuse"
    ></LinkPopup>
    <div v-if="tosafariShow" class="tosafari">
      <div class="content">
        <img
          src="https://tengface-project.oss-cn-shenzhen.aliyuncs.com/tmp/quxiaofei.png"
        />
        <div class="bottom">
          <button @click="tosafariShow = false">我不需要连麦</button>
        </div>
      </div>
    </div>
    <!-- 购物车商品 -->
    <div class="shopping-cart" style="right: 10px;bottom: 230px" v-if="showShoppingType" @click="toGoodsDetailPage">
      <div class="goods-pic">
        <img :src="goodsInfo.cover" alt="" srcset="" />
      </div>
      <p class="title">{{ goodsInfo.name }}</p>
      <div class="pirce">
        <span>￥{{ goodsInfo.price }}</span>
        <span class="go">抢</span>
      </div>
      <van-icon name="cross" class="close" style="top: 10px;right: -4px;" @click.stop="showShoppingType = false" />
    </div>
    
    <!-- 购物车商品弹框 -->
    <van-popup class="shopping-dialog" v-model="showShoppingDialog">
      <div class="shopping-dialog-content">
        <div class="wrapper">
          <div class="goods-content">
            <img class="goods-pic" :src="goodsInfo.cover" width="96" />
            <div class="goods-info">
                <p class="title">{{ goodsInfo.name }}</p>
                <p class="price">￥{{ goodsInfo.price }}</p>
            </div>
          </div>
        </div>
        <div class="shopping-btn" @click="toGoodsDetailPage">立即抢购</div>
      </div>
      <div style="text-align: center;">
        <img src="../../../../statics/imgs/close-white.png" @click="hideShoppingPop" />
        <!-- statics/imgs/close-white.png -->
      </div>
    </van-popup>

    <template v-if="showBuyTipsState">
      <!-- 正在购买商品通知 -->
      <div class="bug-tips user-buy-goods" :class="[showBuyGoodsTips ? 'show' : 'hide']" >
        <img src="../../../../statics/imgs/home/user-buy-goods.png" alt="" srcset="">
        <p class="tips">
          <span class="username">{{ tipsBuyUsername }}</span>
          <span style="flex-shrink: 0;">{{ tipsBuyText }}</span>
        </p>
      </div>
      <!-- 商品购买成功通知 -->
      <div class="bug-tips buy-goods-success" :class="[showBuySuccessGoodsTips ? 'show' : 'hide']">
        <img src="../../../../statics/imgs/home/user-buy-goods-success.png" alt="" srcset="">
        <p class="tips">
          <span class="username">{{ tipsBuySuccessUsername }}</span>
          <span style="flex-shrink: 0;">{{ tipsBuySuccessText }}</span>
          <!-- inventoryNum = -1 表示该商品无限库存 -->
          <span v-if="inventoryNum !== -1">, 库存剩余{{ inventoryNum }}件</span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import handleIm from "../../../kits/im/handleim.js";
import vxxData from "../../../kits/data.js";
import tool from "../../../kits/Tools.js";
import FakeIm from "../../../kits/im/FakeIm.js";
import { mapGetters } from "vuex";
import qs from "qs";
import QRCoder from "qrcoder";
import html2canvas from "html2canvas";
import TFPlayer from "tfplayer";
import { Toast } from "vant";
import { Button } from "vant";
Vue.use(Button);
import { Popup } from "vant";
Vue.use(Popup);
import { Dialog } from "vant";
Vue.use(Dialog);
import { NoticeBar } from "vant";
Vue.use(NoticeBar);
import { Tab, Tabs } from "vant";
Vue.use(Tab).use(Tabs);
import { RadioGroup, Radio } from "vant";
Vue.use(RadioGroup);
Vue.use(Radio);
import { Picker } from "vant";
Vue.use(Picker);
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem);

import launch from "../launch.vue";
import ChatRoom from "../menu/ChatRoom.vue";
import EmbeddedWeb from "../menu/EmbeddedWeb.vue";
import Store from "../menu/Store.vue";
import ImgText from "../menu/ImgText.vue";
import Vote from "../menu/vote.vue";
import List from "../menu/List.vue";
import shake from "../shake.vue";
import VideoReView from "../menu/VideoReView.vue";
import special from "../menu/special.vue";
import payWatch from "../payWatch.vue";
import rightBar from "../rightBar.vue";
import leftBar from "../leftBar.vue";
import proGress from "../proGress.vue";
import pieceWise from "../pieceWise.vue";
import RegisterView from "../RegisterView.vue";
import TelTest from "../telTest.vue";
import LinkPopup from "../LinkPopup.vue";
import ConsultTeacher from "../menu/ConsultTeacher/index.vue";
import tipsView from "../tipsView.vue";
import chatlist from "./chatlist.vue";
import toolBar from "./toolbar.vue";
import goodsList from "../../Modular/menu/goodsList/index.vue"; //./Modular/menu/goodsList/index.vue
import { useOrgConfig } from '../../../kits/useOrgConfig.js'


export default {
  data() {
    return {
      tid: 0,
      tosafariShow: false,
      isCanMucsic: true,
      TelTestShow: false,
      registerViewShow: false,
      fans: null,
      user: "",
      loading: false,
      showControl: true,
      isShowControl: true,
      orientation: "portraint",
      initData: null,
      openRolling: false,
      isRolling: false,
      MerryGoRound: "", //走马灯内容
      videoLinkno: "", //mp4第一个视频
      videoImg: "",
      videoDuration: "00:00:00",
      videoCurrentTime: "00:00:00",
      dsMenu: [], //导航栏
      isPlay: false,
      styleType: 1,
      view_num: 0,
      playerStyle: {},
      showCover: true,
      contentStyle: {}, //内容布局
      showhead: false,
      headtitleBg: "#212126",
      showView: true,
      screenH: 0,
      noPlayH: 0,
      before_ad: [], //广告视频
      directStatus: "not_started", //直播状态
      dispark: false,
      titleName: "",
      isshowgift: false,
      controlTimer: null,
      isShowMidControl: false,
      startTime: "",
      bottomSider: true,
      shareData: {},
      fans_id: "",
      ds_id: "",
      shareRedexist: false,
      shareType: 0,
      shareRed: true,
      musicStatusexist: true,
      musicStatus: true,
      musicPlay: true,
      musicList: [],
      musicIndex: 0,
      musicUrl: "",
      talkredexist: false,
      talkred: true,
      talkredstatus: false,
      talktext: "",
      rewardMoney: 0,
      talkType: 0,
      isShowProgress: false,
      playHeight: 0,
      showMenu: true,
      controlStyle: {},
      rainProbab: 0,
      rainId: "",
      isWeixin: true,
      marqueeheight: 0,
      marqueeStyle: "",
      adIndex: -1,
      haveMenu: true,
      toplist: [],
      showBigTable: false,
      scrollDir: "up",
      shareLimit: true,
      breakPoint: [],
      limitText: "",
      desc: "",
      ds_func: {},
      voteList: "",
      TstartTime: "",
      Tend_time: "",
      loaded: false,
      currentMid: "",
      curCid: 1,
      fullscr: false,
      pieceHeight: 0,
      haveNav: false,
      clarityList: [],
      curClarity: "原画",
      showClarity: false,
      videoIndex: 0,
      isIOS: false,
      barHeight: 0,
      currentTime: 0,
      timeupdate: "",
      myPlayer: "",
      wall_id: "",
      share: {
        title: "",
        dec: "",
        image: "",
        url: "",
      },
      passwordID: "",
      forbid: false,
      totalLike: 0,
      dynamicData: "",
      quanData: null,
      rewardQuan: false,
      rewardredpack: false,
      rewardType: 1,
      imgPath: "",
      vid: "",
      uid: "",
      canBack: true,
      playtimer: null,
      playStart: false,
      picComment: false,
      hot: true,
      topAD: false,
      topObj: {},
      StoreUrl: "",
      storeActive: "",
      pic_url: "",
      uploader: "",
      accessid: "",
      accesskey: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      entered: true,
      imIsLogin: false,
      shopIndex: -1,
      openShop: false,
      buyList: [],
      buyListIndex: -1,
      salesHeight: 0,
      bannerHeight: 0,
      commentList: [],
      isMaster: 0,
      giftList: null,
      inviting: false,
      wallSign: false,
      payPrice: 1,
      tryOpacity: 0,
      tryTime: 5,
      tryPayBtn: false,
      isTrySee: false,
      tryPrice: 1,
      is_pay: false,
      reload: false,
      showPay: false,
      payIndex: -1,
      coupons: [],
      coupon_id: 0,
      ticket_switch: false,
      couponText: "",
      isGradRedStart: false,
      redBagData: {},
      showrobRedlist: false,
      redBaglistData: {},
      ds_pwd: null,
      allot_sale: false,
      allot: {},
      showAllot: false,
      headerUrl: "",
      code: "",
      headerData: "",
      isPlayUI: false,
      canvas: null,
      base64Img: "",
      IMtimer: null,
      showSchool: false,
      showSchoolSuc: false,
      isShowSchoolSure: false,
      showSchoolTip: false,
      isShowAddressList: false,
      isShowAgeList: false,
      isShowClassList: false,
      userClassName: "",
      navitemWidth: 47,
      isFirstPlay: true,
      currLiveDic: null, //直播时的链接
      loginErrroStyle: {},
      isShowLoginErr: false,
      adImages: [],
      isShowAd: false,
      isShowQRimg: false,
      weixincodeUrl:
        "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/tengface.jpg",
      weixintopText: "关注后可收到直播最新动态哦",
      weixinbottomText: "长按关注公众号接收最新动态",
      isNotShowWebRTC: true,
      rtcClient: null,
      rtcRemoteStream: null,
      playerStatus: 1,
      linkDialogVisible: false,
      linkType: 1, // 1 没有连麦  2 用户申请了连麦  3 正在连麦
      heardTimer: null,
      heardVodTimer: null,
      isSupportRTC: true,
      outOfTime: false,
      showConsultTeacher: false,
      showLiveWay: false,
      selectPlayType: 0,
      verify_comment: false,
      channel_id: "",
      isBlack: false,
      openWx_follow: false, //开启微信
      isShowGift: false, //显示点赞送花
      showTeacherBtn: false,
      playerType: "live",
      currentPlayerData: null,
      show_type: 2, //2手机号短信验证码 3账号密码
      is_all_users_muted: false,
      heart_time: 30,
      need_check_bool: true,
      isShowTeacherQrCode: false,
      isShowTeacherBtnTop: false,
      teacher_qrcode_title: "",
      teacher_qrcode_url: "",
      liveType: "open",
      classUserId: null,
      say_self: {
        enabled: false,
        type: "2",
        all: "2",
      },
      showQQPopUp: false,
      showLineSchoolPopUp: false,
      onlineSendMsgNum: 0,
      onlineSednMsgText: "获取验证码",
      onlineSchoolAccount: "",
      onlineSchoolPassword: "",
      onLIneSchoolSMSCode: "",
      loginType: 1, //1账户密码 2 验证码
      noticeObj: {
        open: false,
        content: "",
        time: 0,
      },
      checkNetSchoolTokenTimmer: null,
      showWxPopUp:false,
      noClearScreen:true,
      HeartMode:"",
      im_type:"",
      pageUUID:tool.guid(),
      isyxinImLoginOut:false,
      showGoods:false,
      gid:'',
      goodsIdsList: [],
      isshowCart: false,
      showShoppingDialog: false,
      showBuyTipsState: false,
      showShoppingType: false,
      goodsInfo: {},
      goodsIdsList: [],
      inventoryNum: 0,
      // 正在购买
      showBuyGoodsTips: false,
      tipsBuyTimer: null,
      tipsBuyText:"",
      tipsBuyUsername:"",
      saveUserBuyList: [],
      // 购买成功
      showBuySuccessGoodsTips: false,
      tipsBuySuccessTimer: null,
      tipsBuySuccessText: '',
      tipsBuySuccessUsername: '',
      saveUserBuySuccessList: [],
      im_type:"",
      runObj: {
        open: false,
        fontSize: "",
        fontColor: "",
        fontTrans:1
      },
      copyrightObj: {
        open: false,
        inputValue: "",
        copyrightTrans:1
      },
      videoSpeed: 1,
      userOrgConfigData:{},
      canPlayLive: false
    };
  },
  computed: {
    ...mapGetters({
      businessConfigs: "dsInfo/getBusinessConfigs"
    }),
  },
  watch: {
     canPlayLive(newV) {
      if (newV) {
        this.$nextTick(function () {
          if (this.isIOS) {
            if (
              typeof WeixinJSBridge == 'object' &&
              typeof WeixinJSBridge.invoke == 'function'
            ) {
              WeixinJSBridge.invoke('getNetworkType', {}, (res) => {
                console.error('======去播放了哈=====');
                this.$refs.tfPlayer && this.$refs.tfPlayer.playVideoClicked();
              });
            } else {
               this.$refs.tfPlayer && this.$refs.tfPlayer.playVideoClicked();
            }
          } else {
            this.$refs.tfPlayer && this.$refs.tfPlayer.playVideoClicked();
          }
        });
      }
    },
  },
  components: {
    launch,
    ChatRoom,
    ImgText,
    Vote,
    List,
    EmbeddedWeb,
    Store,
    shake,
    VideoReView,
    special,
    toolBar,
    rightBar,
    leftBar,
    proGress,
    pieceWise,
    RegisterView,
    TelTest,
    payWatch,
    TFPlayer,
    LinkPopup,
    ConsultTeacher,
    tipsView,
    chatlist,
    goodsList
  },
  beforeDestroy() {
    if (this.heardTimer) {
      clearInterval(this.heardTimer);
      this.heardTimer = null;
    }
    if (this.heardVodTimer) {
      clearInterval(this.heardVodTimer);
      this.heardTimer = null;
    }
  },
  async mounted() {
    var that = this;
    this.limitText = tool.getQueryString("text");
    this.tid = tool.getQueryString("tid");
    this.user = tool.getQueryString("fromuser");
    this.ds_id = tool.getQueryDsId();
    this.reload = sessionStorage.getItem("reload");
    this.channel_id = tool.getQueryChannelId();
    try {
      if (!this.ds_id && this.channel_id) {
        if (!window.isExceptionMode) {
          const data = await this.axios.post(
            tool.baseUrl1() + "/customer/channel/getDsIdByChannelId",
            "channel_code=" + this.channel_id
          );
          if (data.data.code == 200) {
            this.ds_id = data.data.data.ds_id;
            tool.setDs_id(this.ds_id);
          } else {
            Toast({message:data.data.message, duration:0})
          }

        }else{
           const data = await this.axios.get(
              tool.tencentOssUrl() + "/ds/channel_cache/channel_"+this.channel_id+".json?" + new Date().getTime() + parseInt(Math.random() * 10e4),{timeout:2000});
            if (data) {
              this.ds_id = data.data.ds_id;
              tool.setDs_id(this.ds_id);
            } else {
            } 
        }
       
      }
    } catch (error) {
      Toast({message:'网络存在问题,请刷新重试', duration:0})
    }

    if (this.ds_id) {
      tool.setDs_id(this.ds_id);
    }

    if (this.ds_id && parseInt(this.ds_id) != this.ds_id) {
      alert("直播间ID错误，请检查链接");
      return;
    }

    this.key += this.ds_id + "/";
    this.imgPath = tool.imgPath();

    sessionStorage.setItem("sid", this.user);

    this.isWeixin = tool.isWeixin();

    //强制关注参数
    if (this.limitText) {
      tool.setCookie(this.limitText, true, 30);
      location.href = location.href.split("&text")[0];
    }

    //断点视频参数
    if (tool.getQueryString("videoIndex")) {
      this.videoIndex = tool.getQueryString("videoIndex");
    }

    if (localStorage.getItem("forbid") == "true") {
      this.forbid = true;
    } else {
      this.forbid = false;
    }

    if (tool.checkPhoneType() == 2) {
      this.isIOS = true;
    }

    if (this.tid) {
      //这里说明是伪直播
      tool.getFakeLiveInfo(this.tid, (isOk, fakeInfo) => {
        if (isOk) {
          tool.getDsInfo(async (dsInFo) => {
            that.liveType = dsInFo.direct_seeding.type;
            tool.login(dsInFo.direct_seeding.appid,dsInFo.direct_seeding.uid,function(userInfo) {
              that.personDataInit(userInfo, dsInFo);
            });
          }, fakeInfo);
        } else {
          alert("网络错误请稍后重试");
        }
      });
    } else {
      //获取直播间信息
      tool.getDsInfo(async (dsInFo) => {
        that.liveType = dsInFo.direct_seeding.type;
        that.uid = dsInFo.direct_seeding.uid;
        that.im_type = dsInFo.direct_seeding.im_type;
        that.initData = dsInFo;
        let myConfig = await useOrgConfig(that.uid)
        that.userOrgConfigData = myConfig
        that.$store.commit('setting/setDefaultConfig', myConfig)
        that.$store.commit('setting/setuId', that.uid)
        // 微信授权登录
        tool.login(that.userOrgConfigData.official_account_appid || dsInFo.direct_seeding.appid,dsInFo.direct_seeding.uid,function(userInfo) {
          if (userInfo && userInfo.showQQPopUp) {
            that.showQQPopUp = true;
          }else if(userInfo && userInfo.showWxPopUp){
            that.showWxPopUp = true;
            tool.LoginJumpWx(dsInFo.direct_seeding.name)
          }
            that.personDataInit(userInfo, dsInFo);
        }, dsInFo.direct_seeding.name);
        // that.classRoomCheckAccess((isNeedLogin)=>{
        //     if (isNeedLogin) {//需要网课登录
        //         that.checkClassLiveUserInfo(dsInFo.direct_seeding.appid,(userInfo)=>{
        //             that.personDataInit(userInfo, dsInFo);
        //         });
        //     }else{
                
        //     }
        // })
      });
    }
    if (tool.checkPhoneType() == 2 && this.isWeixin) {
      this.isSupportRTC = false;
    }
  },
  methods: {
    /**
     * 描述：展示“正在购买”提示
    **/
    showTipsByUserBuy() {
      if(this.saveUserBuyList.length > 0) {
        this.showBuyGoodsTips = true
        const text = this.saveUserBuyList.length > 1 ? `等${this.saveUserBuyList.length}人` : ''
        this.tipsBuyText = `${text} 正在去购买`
        this.tipsBuyUsername = this.saveUserBuyList[0]
        this.saveUserBuyList = []
        this.tipsBuyTimer = setTimeout(() => {
          this.showBuyGoodsTips = false
          if(this.tipsBuyTimer) {
            clearTimeout(this.tipsBuyTimer)
          }
          this.tipsBuyTimer = setTimeout(() => {
            this.showTipsByUserBuy()
          }, 300)
        }, 5000)
      } else {
        clearTimeout(this.tipsBuyTimer)
        this.tipsBuyTimer = null
      }
    },
    /**
     * 描述：展示“购买成功”提示
    **/
    showTipsByUserBuySuccess() {
      if(this.saveUserBuySuccessList.length > 0) {
        this.showBuySuccessGoodsTips = true
        const text = this.saveUserBuySuccessList.length > 1 ? `等${this.saveUserBuySuccessList.length}人` : ''
        this.tipsBuySuccessText = `${text} 购买成功`
        this.tipsBuySuccessUsername = this.saveUserBuySuccessList[0]
        this.saveUserBuySuccessList = []
        this.tipsBuySuccessTimer = setTimeout(() => {
          this.showBuySuccessGoodsTips = false
          if(this.tipsBuySuccessTimer) {
            clearTimeout(this.tipsBuySuccessTimer)
          }
          this.tipsBuySuccessTimer = setTimeout(() => {
            this.showTipsByUserBuySuccess()
          }, 300)
        }, 5000)
      } else {
        clearTimeout(this.tipsBuySuccessTimer)
        this.tipsBuySuccessTimer = null
      }
    },
    toGoodsDetailPage() {
      const { id, jump, payurl } = this.goodsInfo
      if(jump === 1) {
        window.open(payurl)
        return
      }
      this.$router.push({path:`/goodsDetail?id=${id}&uid=${this.uid}&channel_id=${this.channel_id}&dsId=${this.ds_id}`})
    },
    hideShoppingPop() {
      localStorage.setItem('IS_SHOW_ShOPPING_CART', '1')
      this.showShoppingDialog = false
    },
    goodsListCloseBtnClicked() {
      this.showGoods = false
    },
    onShowTeacherList() {
      this.showConsultTeacher = true;
      this.$refs.consultTeacher.switchTimeList();
    },
    async onShowGoodsList() {
      await this.$refs.goodsList.getGoodsList()
            this.showGoods = true;
    },
    async onlineSchoolLoginClick() {
      if (this.onlineSchoolAccount == "") {
        Toast("账号不能为空");
        return;
      }
      if (this.onLIneSchoolSMSCode == "") {
        Toast("验证码不能为空");
        return;
      }
      try {
        const postData = {
          area: 86,
          phone: this.onlineSchoolAccount,
          code: this.onLIneSchoolSMSCode,
          org_id: this.uid,
        };
        // this.showLineSchoolPopUp = false;
        const data = await this.axios.post(
          "https://school.shkt.online/onlineapi/user/index/phoneLogin",
          qs.stringify(postData)
        );
        console.log("data", data);
        if (data.data.code == 200) {
          tool.setCookie("netschool_token", data.data.data.token, 30);
          const postData2 = {
            fans_id: data.data.data.fansId,
            ds_id: this.ds_id,
          };
          console.log("qs.stringify(postData)", qs.stringify(postData2));
          const data2 = await this.axios.post(
            tool.baseUrlSchool() + "/stu/course/dsAuth",
            qs.stringify(postData2)
          );
          if (data2.data.code == 200) {
            if (data2.data.data.result) {
              tool.getUserInfoReloadByToken(data2.data.data.liveToken);
            } else {
              Toast("此账号无权限观看此课程请联系管理员开通");
            }
          } else {
            Toast(data2.data.message);
          }
        } else {
          Toast(data.data.message);
        }
      } catch (error) {
        console.error("onlineSchoolLoginClick", error);
      }
    },
    async onlineSchoolPWDLoginClick() {
      if (this.onlineSchoolAccount == "") {
        Toast("账号不能为空");
        return;
      }
      if (this.onlineSchoolPassword == "") {
        Toast("密码不能为空");
        return;
      }
      try {
        const postData = {
          account: this.onlineSchoolAccount,
          password: this.onlineSchoolPassword,
          org_id: this.uid,
        };
        const data = await this.axios.post(
          tool.baseUrlSchool() + "/user/index/login",
          qs.stringify(postData)
        );
        console.log("data", data);
        if (data.data.code == 200) {
          tool.setCookie("netschool_token", data.data.data.token, 30);
          const postData2 = {
            fans_id: data.data.data.fansId,
            ds_id: this.ds_id,
          };
          console.log("qs.stringify(postData)", qs.stringify(postData2));
          const data2 = await this.axios.post(
            tool.baseUrlSchool() + "/stu/course/dsAuth",
            qs.stringify(postData2)
          );
          if (data2.data.code == 200) {
            if (data2.data.data.result) {
              tool.getUserInfoReloadByToken(data2.data.data.liveToken);
            } else {
              Toast("此账号无权限观看此课程请联系管理员开通");
            }
          } else {
            Toast(data2.data.message);
          }
        } else {
          Toast(data.data.message);
        }
      } catch (error) {
        console.error("onlineSchoolLoginClick", error);
      }
    },
    checkNetSchoolTokenValid() {
      this.axios
        .post(tool.baseUrlSchool() + "/user/index/checkToken")
        .then(function(res) {})
        .catch(function(error) {
          console.log(error);
        });
    },
    qqloginTap() {
      tool.LoginJumpQQ(this.initData.direct_seeding.name)
    },
    wxloginTap() {
      tool.LoginJumpWx(this.initData.direct_seeding.name)
    },
    closeWindow(){
      wx.closeWindow()
    },
    async onlineLineSchoolSendMsg() {
      try {
        const postData = {
          area: 86,
          phone: this.onlineSchoolAccount,
          org_id: this.uid,
        };
        console.log("qs.stringify(postData)", qs.stringify(postData));
        const data = await this.axios.post(
          "https://onlinehy.shkt.online/sms/studentLoginSendSms",
          qs.stringify(postData)
        );
        console.log("data", data);
        if (data.data.code == 200) {
          this.sendMsgStartTimer();
        } else {
          Toast(data.data.message);
        }
      } catch (error) {
        console.error("checkClassLiveUserInfo", error);
      }
    },
    sendMsgStartTimer() {
      this.onlineSednMsgText = "59S";
      this.onlineSendMsgNum = 59;
      this.onlineSchoolTimer = setInterval(() => {
        this.onlineSendMsgNum = this.onlineSendMsgNum - 1;
        if (this.onlineSendMsgNum <= 0) {
          this.onlineSendMsgNum = 0;
          this.onlineSednMsgText = "获取验证码";
          clearInterval(this.onlineSchoolTimer);
          return;
        }
        this.onlineSednMsgText = `${this.onlineSendMsgNum}S`;
      }, 1000);
    },
    showTeacherQrCodeCliced() {
      this.isShowTeacherQrCode = false;
      this.isShowTeacherBtnTop = true;
    },
    showTeacherBtnTopClicked() {
      this.isShowTeacherQrCode = true;
      this.isShowTeacherBtnTop = false;
    },
    playFailed(playType, data) {
      if (playType != 2) {
        Toast("加载视频失败,正在切换备选线路");
        this.$refs.tfPlayer.changePlayType(2);
      } else {
        Toast("加载视频失败,请检查网络");
      }
    },
    onShowFouceAlert() {
      this.isShowQRimg = true;
    },
    changePlayType(type) {
      this.showLiveWay = false;
      this.$refs.tfPlayer.changePlayType(type);
      //走结束连麦流程
      this.$refs.tfPlayer.rtcLinkDown();
      this.linkType = 1;
    },
    isSupportRTCCallBack(value) {
      console.log("isSupportRTCCallBack", value);
    },
    unAutoPlay(message) {
      if (message.type == 511) {
        Dialog.alert({
          message: "正在直播，点击观看精彩直播",
          confirmButtonText: "点击观看",
        }).then(() => {
          this.$refs.tfPlayer.playVideoClicked();
        });
      } else {
        console.error("1371", message.message);
        Toast(message.message);
      }
    },
    consultTeacherCloseBtnClicked() {
      this.showConsultTeacher = false;
    },
    // onShowTeacherList() {
    //   this.showConsultTeacher = true;
    //   this.$refs.consultTeacher.switchTimeList();
    // },
    sendApplyLink() {
      const canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
      if (tool.isWeixin() && this.isIOS && !canLink) {
        this.tosafariShow = true;
        return;
      }
      this.linkType = 1;
      this.linkDialogVisible = true;
    },
    sendEndLink() {
      this.linkDialogVisible = true;
    },
    playerStatusChange(to, playType) {
      this.playerStatus = to;
      this.selectPlayType = playType;
      console.log("播放状态变化了", to, playType);
      if (to == 2) {
        this.hideMusicAndStop();
      } else if (to == 1 || to == 3) {
        this.showMusic();
      }
    },
    linkTypeChange(to) {
      this.linkType = to;
      console.log("连麦状态变化了");
    },
    tryLogin() {
      location.reload();
    },
    loadAll(data) {
      var that = this;
      // data.direct_seeding.play_style = 3
      this.initData = data;
      //this.isRegisterData();
      this.loaded = true;
      this.init();
      //获取动态数据接口
      // alert("sdfsdf"+that.fans_id)
      if (that.fans_id) {
        !window.isExceptionMode && this.getDynamicData();
        this.isShowLoginErr = false;
        Toast.clear();
      } else {
        // this.isShowLoginErr = true;
        if (!this.showQQPopUp && !this.showWxPopUp) {
          //如果不是QQ弹窗
          Toast.clear();
          tool.clearFansInfo();
          Toast("登录失败！");
          setTimeout(function() {
            location.reload();
          }, 1000);
        }
      }

      // this.initUI();

      setTimeout(function() {
        that.handleTabClick(0);
      }, 300);

      setTimeout(function() {
        that.setControl();
        var clarity = localStorage.getItem("clarity");
        if (clarity == "hls_fhd") {
          that.curClarity = "超清";
        } else if (clarity == "hls_hd") {
          that.curClarity = "高清";
        } else if (clarity == "hls_standard") {
          that.curClarity = "标清";
        } else if (clarity == "hls_smooth") {
          that.curClarity = "流畅";
        } else if (clarity == "playback" || !clarity) {
          that.curClarity = "原画";
        }
      }, 300);

      this.playBack();
      //数据统计上报接口
      // this.resize();
      // 上报渠道信息
      if (this.fans_id && !window.isExceptionMode) {
        this.channelInfoUpload();
      }
    },
    personDataInit(fans, dsInfo) {
      //获取用户信息
      var that = this;
      //重缓存中获取数据
      this.fans = fans;
      this.fans_id = this.fans.fans_id;
      this.headerUrl = this.fans.header;

      var queryData = tool.getQueryData(location.href);
      var hasToken = false;
      if (queryData.token !== "" && queryData.token) {
        hasToken = true;
      }
      var otherLogin = getQueryString("other");
      //替换邀请码
      if (
        (this.user != this.fans_id && this.fans_id && this.fans.token) ||
        (this.isIOS && this.isWeixin && !hasToken && !otherLogin)
      ) {
        var data = tool.getQueryData(location.href);
        data.fromuser = this.fans_id;
        if (this.isIOS && this.isWeixin && !otherLogin) {
          data.token = this.fans.token;
        }
      }

      // 上报邀请数据
      if (this.user && this.fans_id) {
        this.invite();
      }

      // 加载微信分享参数
      !window.isExceptionMode && that.shareToWeChat();
      //获取直播间信息
      this.loadAll(dsInfo);
    },
    classRoomCheckAccess(callback){
      if (this.liveType == 'class') {
          this.axios.post(
              tool.baseUrl1() + "/customer/index/qryUserConfigs",
              qs.stringify({ uid: this.uid })
            )
            .then(async (res) => {
              var data1 = res.data.data;
              if (res.data.code == "200") {
                if (data1) {
                  let businessConfigsTmp = {};
                  data1.forEach((item) => {
                    businessConfigsTmp[item.key] = item.value == "true";
                  });

                  if (businessConfigsTmp.classroom_check_access) {
                      callback && callback(true)
                  }else{
                    callback && callback(false)
                  }
                }
              }
            }).catch(function(error) {
              callback && callback(false)
              console.log(error);
            });
      }else{
          callback && callback(false)
      }
        
    },
    async checkClassLiveUserInfo(appid,callback) {
      let userInfo  = tool.getCacheUserInfo(appid);
      if (userInfo) {
          try {
            const postData = {
              fans_id: userInfo.fans_id,
              ds_id: this.ds_id,
            };
            console.log(
              "qs.stringify(postData)",
              qs.stringify(postData)
            );
            const data = await this.axios.post(
              tool.baseUrlSchool() + "/stu/course/dsAuth",
              qs.stringify(postData)
            );
            if (data.data.code == 222222) {
              this.showLineSchoolPopUp = true;
              this.loaded = true;
            } else if (data.data.code == 200) {
              console.log("有权限,可以看");
              callback && callback(userInfo)
              this.checkNetSchoolTokenValid();
                setInterval(() => {
                this.checkNetSchoolTokenValid();
              }, 10000);
            } else {
              console.log("1519", data);
              Toast(data.data.message);
              this.showLineSchoolPopUp = true;
              this.loaded = true;
            }
          } catch (error) {
            console.error("checkClassLiveUserInfo", error);
          }
        } else {
           console.error("checkClassLiveUserInfo-showLineSchoolPopUp");
          this.showLineSchoolPopUp = true;
          this.loaded = true;
        }

    },
    isRegisterData() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios
        .post(tool.baseUrl3() + "/infoCollection/isRegister", option)
        .then(function(data) {
          var data = data.data;
          if (data.code == 200) {
            if (data.data.isRegister == 0) {
              var dateStr = "2019-03-31 22:00:00";
              dateStr = dateStr.substring(0, 19);
              dateStr = dateStr.replace(/-/g, "/");
              var timestamp = new Date(dateStr).getTime();
              if (timestamp > new Date().getTime()) {
                that.showSchool = true;
              }
            } else {
              that.userClassName =
                data.data.where.area +
                data.data.where.school +
                data.data.where.grade +
                data.data.where.class;
              that.showSchoolTip = true;
            }
          }
        })
        .catch(function(data) {
          console.log("错误" + data);
        });
    },
    getDynamicData() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios
        .post(tool.baseUrl2() + "/init/getDynamicData", option)
        .then(function(data) {
          var data = data.data;
          if (data.code == 200) {
            that.dynamicData = data.data;
            // that.view_num = data.data.view_num;
            that.totalLike = data.data.like_num;

            if (data.data.share_red_chance > 0) {
              //开启分享得红包
              that.shareRedexist = true;
              that.shareType = 0;
            } else if (data.data.share_coupon_chance > 0) {
              //开启分享得卡券
              that.shareRedexist = true;
              that.shareType = 1;
            }

            if (data.data.pwd_red_chance > 0) {
              //口令的红包
              // that.talkredexist = true;
              // that.talkType = 0;
            } else if (data.data.pwd_coupon_chance > 0) {
              //口令的卡券
              that.talkredexist = true;
              that.talkType = 1;
            }

            if (data.data.red_rain != null) {
              that.rainProbab = data.data.red_rain.percent;
              that.rainId = data.data.red_rain.msgid;
              that.$refs.redrain.redbagRain();
            }
          }
        })
        .catch(function(data) {
          console.log("错误" + data);
        });
    },
    switchVideo(item, index) {
      //切换视频信息
      if (index == this.videoIndex) {
        return;
      }
      this.videoIndex = index;
      this.videoSpeed = 1
    },
    getISBack(callBack) {
	  
	  //上报域名小程序
      this.domainMiniProgrameReport();

      if (window.isExceptionMode) {
        callBack && callBack(false);
        return
      }
      let that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios
        .post(tool.baseUrl2() + "/ds/getIsBlack", option, {
          credentials: false,
          emulateJSON: true,
        })
        .then((data) => {
          if (data.data.code == 200) {
            if (data.data.data.in_black == "yes") {
              that.isBlack = true;
              callBack && callBack(true);
            } else {
              callBack && callBack(false);
            }
          } else if (data.data.code != 100068 && data.data.code != 100067) {
            callBack && callBack(false);
          }
        })
        .catch((data) => {
          callBack && callBack(false);
          console.log("错误" + data);
        });
    },
    invite() {
      if (this.user && this.fans_id != this.user) {
        var that = this;
        var option =
          "invite_id=" +
          this.user +
          "&ds_id=" +
          this.ds_id +
          "&fans_id=" +
          this.fans_id;

        if (this.tid) {
          option = option + "&tid=" + this.tid;
        }
        this.axios
          .post(tool.baseUrl3() + "/invite/index", option, {
            credentials: false,
            emulateJSON: true,
          })
          .then(function(data) {
            var data = data.data;
          })
          .catch(function(data) {
            console.log("错误" + data);
          });
      }
    },
    sedTalk() {
      this.$refs.toolbar.sendTalk(
        this.talktext,
        this.passwordID,
        this.talkType
      );
      this.talkredstatus = false;
    },
    showtalkredpoup() {
      this.talkredstatus = !this.talkredstatus;
    },
    colsetalkred() {
      this.talkred = false;
    },
    showtalk(data) {
      this.rewardType = 1;
      if (this.talkType == 0) {
        this.rewardredpack = true;
        this.rewardMoney = data.money;
        this.talkred = false;
      } else {
        this.rewardQuan = true;
        this.quanData = data;
      }
    },
    closeRedpack() {
      this.rewardredpack = false;
    },
    closeQuan() {
      this.rewardQuan = false;
    },
    getMusic() {
      if (this.initData.music_list) {
        this.musicList = this.initData.music_list;
        var self = this;
        setTimeout(function() {
          self.initMusic();
        }, 500);
      }
    },
    setMusic() {
      var audio = document.getElementById("audio");
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    stopMusic() {
      //如果有音乐关闭音乐
      var audio = document.getElementById("audio");
      if (audio) {
        audio.pause();
      }
      // 移除音乐监听
      document.body.removeEventListener("click", this.playmusic);
    },
    hideMusicAndStop() {
      this.stopMusic();
      this.musicStatus = false;
    },
    showMusic() {
      this.musicStatus = true;
    },
    initMusic() {
      var that = this;
      var audio = document.getElementById("audio");
      this.musicUrl = this.musicList[0].url;
      audio.addEventListener("play", function() {
        that.musicPlay = true;
      });
      audio.addEventListener("pause", function() {
        that.musicPlay = false;
      });
      audio.addEventListener("ended", function() {
        if (that.musicList.length > 0) {
          that.musicIndex++;
          if (that.musicIndex == that.musicList.length) {
            that.musicIndex = 0;
          }
          that.musicUrl = that.musicList[that.musicIndex].url;
          audio.load();
          setTimeout(function() {
            audio.play();
          }, 300);
        }
      });
      this.triggerAudio();
    },
    resize() {
      var that = this;
      window.onresize = function(e) {
        if (that.isIOS) {
          return false;
        }
        //页面大小改变了
        var clientH = document.documentElement.clientHeight;
        var screenH = window.screen.height;
        var w = window.screen.width;
        //判断是否进入播放模式但是没有横屏  全屏
        that.fullscr = false;
        if (that.orientation == "portraint") {
          if (clientH != that.noPlayH) {
            if (clientH > that.noPlayH) {
              that.playUI();
            }
          } else {
            that.initUI();
          }
        } else {
          if (that.screenH != screenH && that.noPlayH != clientH) {
            //进入横屏状态
            that.fullScreenUI();
          } else {
            //退出横屏状态
            that.orientation = "portraint";
            that.initUI();
          }
        }
      };
    },
    triggerAudio() {
      document.body.addEventListener("click", this.playmusic);
    },
    playmusic() {
      var audio = document.getElementById("audio");
      audio.play();
      document.body.removeEventListener("click", this.playmusic);
    },
    cash() {
      this.$router.push({
        name: "UserInfo",
      });
    },
    cards() {
      this.$router.push({
        name: "cards",
      });
    },
    closeload() {
      if (!this.loading) {
         if (!this.showQQPopUp && !this.showWxPopUp) {
              this.canPlayLive = true;
          }
      }
      this.loading = true;
    },
    registerViewClose() {},
    limit() {
      var passwd = this.ds_pwd.params.http_url;
      var today = new Date().toLocaleDateString();

      if (this.ds_pwd.params.view_type == "password_view") {
        console.log(localStorage.getItem("passwordDay"));
        if (
          localStorage.getItem("passwordDay") == null ||
          localStorage.getItem("passwordDay") != today
        ) {
          this.$router.push({
            name: "payWatch",
            params: {
              type: 1,
            },
          });
        } else {
          this.shareLimit = true;
        }
      } else if (this.ds_pwd.params.view_type == "allot_sale_view") {
        this.allot_sale = true;
        this.allot = this.initData.ds_pwd.params;
        this.allot.title = this.initData.direct_seeding.name;
        //需要付费观看
        // this.ispay();
      } else {
        //需要付费观看
        // this.ispay();
      }
    },
    ispay() {
      var that = this;
      var url = tool.baseUrl() + "/directSeeding/ticket/isPayed";
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == "200") {
            if (data.data.is_pay == 0) {
              if (that.ds_pwd.params.view_type == "allot_sale_view") {
                setTimeout(function() {
                  that.$router.push({
                    path: "/payWatch/3/" + that.fans_id,
                  });
                }, 2000);
              } else {
                if (that.isTrySee) {
                  that.is_pay = false;
                } else {
                  that.$router.push({
                    name: "payWatch",
                    params: {
                      type: 2,
                    },
                  });
                }
              }
            } else {
              if (that.isTrySee) {
                that.is_pay = true;
              } else {
                that.shareLimit = true;
              }
            }
          }
        })
        .catch(function(res) {
          Toast("请求错误" + res.data.message);
        });
    },
    hidefunc() {
      var audio = document.getElementById("audio");
      console.log(audio);
      if (audio) {
        if (this.shareRedexist) {
          this.shareRed = false;
        }
        if (this.musicStatusexist) {
          audio.pause();
          this.musicStatus = false;
        }
      }
    },
    playerListener(data) {
      if (data.playType == "vod") {
        this.playerType = "vod";
        if (data.type == "timeupdate") {
          this.currentPlayerData = data;
        } else if (data.type == 'speed') {
          this.handlePlaySpeed(data.value)
        }
      }
    },
    showfunc() {
      if (this.talkredexist) {
        this.talkred = true;
      }
      if (this.shareRedexist) {
        this.shareRed = true;
      }
      if (this.musicStatusexist) {
        this.musicStatus = true;
      }
    },
    talkredend() {
      this.talkredexist = false;
    },
    shareredend() {
      this.shareRedexist = false;
    },
    init() {
      var that = this;
      this.myPlayer = document.getElementById("myVideo");

      this.titleName = this.initData.direct_seeding.name;
      if (this.initData.direct_seeding.style != 0) {
        this.styleType = this.initData.direct_seeding.style;
      }
      if (this.initData.comment_list) {
        this.commentList = this.initData.comment_list;
      }

      document.title = this.initData.direct_seeding.name;
      this.uid = this.initData.direct_seeding.uid;
      this.giftList = this.initData.gift_list;
      this.ds_pwd = this.initData.ds_pwd;
      this.noPlayH = document.documentElement.clientHeight;
      this.screenH = window.screen.height;

      this.dsMenu = this.initData.ds_menu;

      for (let i = 0; i < this.dsMenu.length; i++) {
        if (this.dsMenu[i].cid == 9) {
          this.shopIndex = i;
          this.openShop = true;
          this.salesHeight = 24;
        }
      }

      this.navitemWidth =
        (window.screen.width - 62.5 - 44) / this.dsMenu.length;

      this.breakPoint = this.initData.direct_seeding.break_point
        ? this.initData.direct_seeding.break_point
        : [];

      this.voteList = this.initData.vote_list;

      if (
        this.initData.wall_sign_conf != null &&
        this.initData.wall_sign_conf.is_open != 0
      ) {
        this.wall_id = this.initData.wall_sign_conf.wall_id;
        this.payPrice = this.initData.wall_sign_conf.price;
        this.wallSign = true;
      }

      vxxData.verifyCode = this.initData.verifyCode;

      if (this.dsMenu.length == 0) {
        this.haveMenu = false;
      }

      this.is_all_users_muted =
        this.initData.direct_seeding.comment_on_off == 0;

      this.fullscr = false;
      //功能解析
      var Obj = this.ds_func;
      for (let j of this.initData.ds_func) {
        Obj[j.module] = j.params || true;
        if (j.module == "red_password" || j.module == "coupon_password") {
          this.passwordID = j.module.id;
        } else if (j.module == "master") {
          //主持人功能
          if (this.fans_id == j.params.fans_id) {
            this.isMaster = 1;
          }
          console.log(this.isMaster + "////");
        }

        if (j.module == "say_self") {
          //自嗨
          this.say_self = {
            enabled: true,
            type: j.params.type,
            all: j.params.all,
          };
        }
      }

      var obj2 = {};
      for (let j of this.initData.ds_func) {
        obj2[j.module] = j;
      }

      this.ds_func = Obj;

      //判断是否是黑名单

      this.fans_id &&
        this.getISBack((isBlack) => {
          if (!isBlack) {
            this.loginIM();//登录IM
            if (
              obj2.view_auth &&
              (obj2.view_auth.params.view_type == "white_num_view" ||
                obj2.view_auth.params.view_type == "account_white_list")
            ) {
              console.log("account_white_list", obj2.view_auth.params);
              //白名单
              if (obj2.view_auth.params.view_type == "white_num_view") {
                that.need_check_bool = obj2.view_auth.params.need_check == 1;
              }
              //开启了手机号密码或者账号密码
              var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
              this.axios
                .post(tool.baseUrl1() + "/wap/index/whiteLoginCheck", option, {
                  fans_id: this.fans_id,
                  credentials: false,
                  emulateJSON: true,
                })
                .then(function(res) {
                  if (res.data.code == 200) {
                    if (res.data.data.is_white_checked == "true") {
                      that.TelTestShow = false;
                      console.log("用户已验证");
                      //心跳
                      that.isWeixinUserCheck((isSuccess)=>{
                          isSuccess && that.getHeartMode();
                      })
                    } else {
                      if (
                        obj2.view_auth.params.view_type == "account_white_list"
                      ) {
                        //账号白名单
                        that.show_type = 3;
                      } else {
                        that.show_type = 2;
                      }

                      that.TelTestShow = true;
                      console.log("用户未验证");
                    }
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
                .catch(function(res) {
                  Toast("请求错误" + res.data.message);
                });
            } else {
              //没有开启白名单 //地理位置上报
              this.isWeixinUserCheck((isSuccess)=>{
                  isSuccess && this.getHeartMode();
              })
            }
          }
        });

      if (obj2.check_play && obj2.check_play.enabled == "yes") {
        //开启了登记观看
        let that = this;
        var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
        if (this.fans_id) {
          this.registerViewShow = true;
          this.axios
            .post(tool.baseUrl1() + "/wap/index/isRegist", option, {
              ds_id: this.dsId,
              fans_id: this.fans_id,
              credentials: false,
              emulateJSON: true,
            })
            .then(function(res) {
              if (res.data.code == 200) {
                if (res.data.data.isRegist == "yes") {
                  that.registerViewShow = false;
                  console.log("用户已登记");
                } else {
                  that.registerViewShow = true;
                  console.log("用户未登记");
                }
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(function(res) {
              Toast("请求错误" + res.data.message);
            });
          console.log("用户开启了登记观看");
        }
      }

      if (Obj.rolling) {
        //跑马灯
        this.openRolling = true;
        this.isRolling = true;
        this.MerryGoRound = Obj.rolling.text.replace(/\d{11}/g, function(data) {
          return '<a href="tel:' + data + '">' + data + "</a>";
        });
        this.scrollDir = Obj.rolling.position;
        this.marqueeStyle =
          ";color:" +
          Obj.rolling.color +
          ";font-size:" +
          Obj.rolling.fontsize +
          "px;";
        if (this.scrollDir == "down") {
          this.marqueeheight = -20;
          this.marqueeStyle += "top:56vw";
        } else {
          this.barHeight = 20;
        }
      }

      // if (Obj.bg_music) {
      //   //开启背景音乐
      //   this.getMusic();
      // } else {
      //   this.musicStatusexist = false;
      // }

      if (Obj.before_ad) {
        //广告视频
        if (Obj.before_ad.user_type == 1) {
          this.before_ad = [
            {
              url: Obj.before_ad.ad_url,
            },
          ];
        } else {
          this.before_ad = JSON.parse(Obj.before_ad.video_list);
        }
      }

      if (Obj.gift) {
        //开启礼物
        this.isshowgift = true;
      }

      // if (Obj.consulting_teacher) {
      //   this.showTeacherBtn = true;
      // }

      if (!Obj.boot_pic) {
        //关闭大图
        this.loading = true;
        //播放
        if (!this.showQQPopUp && !this.showWxPopUp) {
            this.canPlayLive = true; 
        }
      }

      if (Obj.share) {
        //自定义分享功能
        this.shareData = Obj.share;
      }

      // if (Obj.top_list) {
      //   //开启榜单
      //   this.toplist = Obj.top_list.type;
      // }

      if (Obj.verify_comment) {
        //开启评论审核
        this.verify_comment = true;
      }
      console.log("开启榜单", Obj);

      if (Obj.big_turn_table && this.initData.big_turn_table) {
        //大转盘
        if (this.isWeixin) {
          this.showBigTable = true;
          this.TstartTime = this.initData.big_turn_table.start_time;
          this.Tend_time = this.initData.big_turn_table.end_time;
          this.$refs.left.timeSwitch(this.TstartTime, this.Tend_time);
        }
      }

      // if (Obj.nav) {
      //   //开启导航条
      //   this.haveNav = true;
      //   this.pieceHeight = 40;
      // }

      // if (Obj.pic_comment) {
      //   //图文评论
      //   this.picComment = true;
      // }

      // if (Obj.top_ad) {
      //   //顶部广告
      //   this.topAD = true;
      //   this.topObj = Obj.top_ad;
      // }

      if (Obj.hot) {
        //热度
        this.hot = true;
      } else {
        this.hot = false;
      }

      if (Obj.wx_follow) {
        this.openWx_follow = true;
        this.weixincodeUrl = Obj.wx_follow.pic_url;
        this.weixintopText = Obj.wx_follow.remark;
        this.weixinbottomText = Obj.wx_follow.wx_under_des;
        this.isShowQRimg = Obj.wx_follow.float == "yes";
        // this.isShowQRimg = Obj.wx_follow.wx_show_now == "yes";
      }
      if (Obj.shopping_cart) {
        //开启购物车
        this.isshowCart = true
        if(Obj.shopping_cart.length > 0) {
          const { type, shangpingID } = Obj.shopping_cart[0]
          // 如果已经显示过了，再次返回到首页则不再显示购物车弹框
          const isFirstShow = localStorage.getItem('IS_SHOW_ShOPPING_CART')
          if(isFirstShow !== '1') {
            if(type === '3') {
              this.showShoppingDialog = true
            } else if(type === '2') {
              this.showShoppingType = true
            }
            // 标记已显示
            localStorage.setItem('IS_SHOW_ShOPPING_CART', '1')
          }
          if(type !== '1') {
            // 二、三购物车样式只会有一个商品信息
            this.goodsInfo = shangpingID[0]
            this.goodsIdsList = [this.goodsInfo.id]
          } else {
            // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
            this.goodsInfo = {}
            this.goodsIdsList = shangpingID
          }
        }
      } else {
        localStorage.removeItem('IS_SHOW_ShOPPING_CART')
      }
      // 是否开启购买提示
      if(Obj.purchase_prompt) {
        this.showBuyTipsState = true
      }
      // if (Obj.ad) {
      //   this.isShowAd = true;
      //   this.adImages = Obj.ad;
      //   this.bannerHeight = 67;
      // }

      if (Obj.screen_image) {
        this.isShowTeacherQrCode = true;
        this.isShowTeacherBtnTop = false;
        this.teacher_qrcode_title = Obj.screen_image.title || "";
        this.teacher_qrcode_url = Obj.screen_image.image || "";
      }
      // 公告
      if (Obj.notice) {
        this.noticeObj = {
          open: true,
          content: Obj.notice.content,
          time: Obj.notice.time,
        };
      }
      // if (this.isWeixin) {
      //   this.$refs.right.dsFunc(Obj);
      // }

      if (this.ds_pwd.enabled == "yes") {
        //开启观看权限
        this.couponText = this.ds_pwd.params.text;
        if (this.ds_pwd.params.is_try_see == 1) {
          this.tryTime = this.ds_pwd.params.watch_time;
          this.tryPrice = this.ds_pwd.params.price;
          this.isTrySee = true;
        } else {
          this.shareLimit = false;
        }
        this.ticket_switch =
          this.ds_pwd.params.ticket_switch == 1 ? true : false;
        setTimeout(function() {
          that.limit();
        }, 500);
      }

      //视频开屏图片
      this.videoImg = this.initData.direct_seeding.pic_url;
      //直播状态
      this.directStatus = this.initData.direct_seeding.direct_status;

      var clarity = localStorage.getItem("clarity");
      //解析播放地址
      if (this.directStatus == "end") {
        if (this.breakPoint.length > 0) {
          if (clarity) {
            if (this.breakPoint[0][clarity]) {
              this.videoLinkno = this.breakPoint[0][clarity];
            } else {
              if (this.breakPoint[0].hls_hd) {
                this.videoLinkno = this.breakPoint[0].hls_hd;
              } else {
                this.videoLinkno = this.breakPoint[0].playback;
              }
            }
          } else {
            if (this.breakPoint[0].hls_hd) {
              this.videoLinkno = this.breakPoint[0].hls_hd;
            } else {
              this.videoLinkno = this.breakPoint[0].playback;
            }
          }
          this.videoImg = this.breakPoint[0].pic_url;
          this.getClarity(this.breakPoint[0]);
        }
      } else if (this.directStatus == "running") {
        this.videoLinkno = this.initData.pull_url.m3u8_url;
        var live = {};
        live.pic_url = this.initData.direct_seeding.pic_url;
        live.title = this.initData.direct_seeding.name;
        live.playback = this.initData.pull_url.m3u8_url;
        live.create_time = this.initData.direct_seeding.start_time;

        this.currLiveDic = live;
        this.breakPoint.unshift(live);
      } else {
        if (this.before_ad.length > 0) {
          this.videoLinkno = this.before_ad[0].url;
          var live = {};
          live.pic_url = this.initData.direct_seeding.pic_url;
          live.title = this.initData.direct_seeding.name;
          live.create_time = this.initData.direct_seeding.start_time;
          live.playback = this.before_ad[0].url;
          this.currLiveDic = live;
          this.breakPoint.unshift(live);
        } else {
          this.videoIndex = -1;
        }
      }
      if (this.videoIndex > 0) {
        document.title = this.breakPoint[this.videoIndex].title;
        this.titleName = this.breakPoint[this.videoIndex].title;
        this.getClarity(this.breakPoint[this.videoIndex]);
      }
      this.startTime = this.initData.direct_seeding.start_time;
      // this.myPlayer.load();
    },
    getClarity(obj) {
      var hls_fhd = {},
        hls_hd = {},
        hls_standard = {},
        hls_smooth = {},
        playback = {};
      this.clarityList = [];
      if (obj.hls_fhd) {
        hls_fhd.clarity = "超清";
        hls_fhd.url = obj.hls_fhd;
        hls_fhd.clarityMode = "hls_fhd";
        this.clarityList.push(hls_fhd);
      }
      if (obj.hls_hd) {
        hls_hd.clarity = "高清";
        hls_hd.url = obj.hls_hd;
        hls_hd.clarityMode = "hls_hd";
        this.clarityList.push(hls_hd);
      }
      if (obj.hls_standard) {
        hls_standard.clarity = "标清";
        hls_standard.url = obj.hls_standard;
        hls_standard.clarityMode = "hls_standard";
        this.clarityList.push(hls_standard);
      }
      if (obj.hls_smooth) {
        hls_smooth.clarity = "流畅";
        hls_smooth.url = obj.hls_smooth;
        hls_smooth.clarityMode = "hls_smooth";
        this.clarityList.push(hls_smooth);
      }
      if (obj.playback) {
        playback.clarity = "原画";
        playback.url = obj.playback;
        playback.clarityMode = "playback";
        this.clarityList.push(playback);
      }

      var clarity = localStorage.getItem("clarity");

      //默认画质
      if (obj.hls_hd) {
        this.videoLinkno = obj.hls_hd;
        this.curClarity = "高清";
        localStorage.setItem("clarity", "hls_hd");
      } else {
        this.curClarity = "原画";
        localStorage.setItem("clarity", "playback");
        this.videoLinkno = obj.playback;
      }
    },
    channelInfoUpload() {
      var that = this;
      var option =
        "ds_id=" +
        this.ds_id +
        "&fans_id=" +
        this.fans_id +
        "&uid=" +
        this.uid +
        "&channel_code=" +
        this.channel_id;
      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }
      that.axios
        .post(tool.baseUrl1() + "/customer/channel/channelInfoUpload", option)
        .then(function(data) {})
        .catch(function(data) {
          console.log(data);
        });
    },
    isWeixinUserCheck(callback){
        if (this.fans && this.fans.nick == "微信用户" && this.isWeixin) {
            let isSuccess = false;
            wx.getNetworkType({
              success:function (res) {
                isSuccess = true;
                console.error("isWeixinUserCheck---success")
              },
              fail:function () {
                isSuccess = false;
                console.error("isWeixinUserCheck---fail")
              },
              complete:function (res) {
                callback(isSuccess)
                console.error("isWeixinUserCheck---complete",isSuccess)
              },
            });
        }else{
          callback(true)
        }
    },
    addPageViewDatas() {
      var that = this;
      var option =
        "ds_id=" +
        this.ds_id +
        "&fans_id=" +
        this.fans_id +
        "&cip=" +
        returnCitySN["cip"] +
        "&cname=" +
        returnCitySN["cname"] +
        "&cid=" +
        returnCitySN["cid"] +
        "&uid=" +
        this.uid +
        "&channel_ds_code=" +
        this.channel_id +
        "&terminal_type=1" +
        "&interval=" +
        this.heart_time;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      that.axios
        .post(tool.baseUrlUser() + "/app/index/come_in", option)
        .then((data) => {
          that.heard(5000);
        })
        .catch((data) => {
          console.log(data);
        });
    },
    async loginYunXinIM(type){ // 1 im  2 心跳
        const param = "fans_id=" + this.fans_id + "&chatroomId=" + this.initData.direct_seeding.chatroom_id
        this.errorReport({search:`云信日志${this.fans_id}`,msg:"获取云信token2",error:param})
        
        let yxInfo = null;
        try {
          if (window.isExceptionMode) {
             const imDataNet = await this.axios.post(`${tool.scfURL()}/api/login/getYxToken`,
                param
              );
              console.error('imDataNet', imDataNet);
              yxInfo = imDataNet.data.data;
          }else { 
              const  imDataNet = await this.axios.post(tool.baseUrl2()+"/init/getYxToken",param)
              yxInfo   = imDataNet.data.data
              console.error("imDataNet",imDataNet)
          }
        } catch (error) {
         
        }

        let UserType = 'old'
        let channelInfoStr = ""
          //标签
        let marktags = ""

        if (!window.isExceptionMode) {
             if (this.channel_id) {
                try {
                  const  userparam = "fans_id=" + this.fans_id + "&ds_id=" + this.ds_id + "&terminal_type=1" + "&channel_ds_code="+ this.channel_id
                  const  userDataInfo = await this.axios.post(tool.baseUrlUser()+"/app/index/getUserDataInfo",userparam,{timeout:3000})
                  
                  let  firstUser  = userDataInfo.data.data.first
                  let  newUser    = userDataInfo.data.data.new
                  if (firstUser == 1) {
                    UserType = 'first'
                  } else if (newUser == 1) {
                    UserType = "new"
                  }
                  if (userDataInfo.data.data.channel_id) {
                    let channelInfo = {
                      channel_name:userDataInfo.data.data.channelName,
                      channel_id:userDataInfo.data.data.channel_id,
                      grouping:userDataInfo.data.data.groupId,
                    }
                    channelInfoStr = JSON.stringify(channelInfo)
                  }
                  
              } catch (error) {
                  
              }
            }
          
            try {
              const param1 = "fansId=" + this.fans_id
              const  imDataNet = await this.axios.post(tool.baseUrl1()+"/tags/getFromFansId",param1,{timeout:3000})
              let marktagsTmp = imDataNet.data.data[this.fans_id]
              if(marktagsTmp && marktagsTmp.length >0){
                marktags = JSON.stringify(imDataNet.data.data[this.fans_id])
              }
              console.log("标签===",marktags)
            } catch (error) {
            }
        }
       

        if (yxInfo) {
             let loginParams = {
                appKey:yxInfo.appKey,
                yxToken:yxInfo.yxToken,
                fans_id:this.fans_id,
                token:yxInfo.token,
                address:yxInfo.addr,
                uid:this.uid,
                ds_id:this.ds_id,
                sessionID:this.pageUUID,
                identifier:this.fans_id,
                identifierNick : this.fans.nick,
                header: this.fans.header,
                headurl: this.fans.header,
                chatroomId: this.initData.direct_seeding.chatroom_id,
                tags:[this.fans_id || '0',  this.ds_id || '0','0',this.channel_id || '0', '1','0',UserType],
                custom:[this.fans_id || '0',  this.ds_id || '0','0',this.channel_id || '0', '1','0',UserType,channelInfoStr,marktags],
              }
              if (type == 1) { //im登录
                handleIm.loginIM(loginParams,2,{
                setMsgListener:this.onReceivedMsgCallBack,
                setMemberMsgListener:this.onReceivedP2PMsgCallback,
                setImStatusListener:(data)=>{
                     if (data.error == "kicked") {
                       this.yxImChatRoomStatusListener("kicked")
                    }
                }
              })
            }else {
              handleIm.loginYunXinChatRoom(loginParams,{
                setImStatusListener:(data)=>{
                    if (data.error == "kicked") {
                       this.yxImChatRoomStatusListener("kicked")
                    }else if (data.error == "noconnect") {
                       this.yxImNoConnectListener()
                    }
                }
              })
            }
        }
    },
    yxImLogListenerCB(message,error){
      this.errorReport({search:`云信日志${this.fans_id}`,msg:message,error:error})
    },
    yxImChatRoomStatusListener(status){ //云信聊天室回调
        if (status == "kicked") {
          this.isyxinImLoginOut = true
          if (this.heardTimer) {
            clearInterval(this.heardTimer)
            this.heardTimer = null
          }
          handleIm.logout(()=>{});
        }
    },
    yxImNoConnectListener(){
       if (this.HeartMode == '3' && !this.isBlack) {
          this.addPageViewDatas()
       }
    },
    getHeartMode(){
        if (this.initData.direct_seeding.im_type == 2) { //1 腾讯IM 2网易IM
          return;
        }
         //开启了手机号密码或者账号密码
        this.errorReport({msg:"获取心跳模式"})
        var option = "ds_id=" + this.ds_id;
        this.axios
          .post(tool.baseUrl2() + "/init/getHeartMode", option)
          .then((res) =>{
            this.errorReport({msg:"心跳模式",HeartMode:res})
            if (res.data.code == 200) {
                 this.HeartMode = res.data.data.mode;
                 if (res.data.data.mode == '2') {
                   this.addPageViewDatas()
                 }else if (res.data.data.mode == '3') {
                  //  this.addPageViewDatas()
                   this.loginYunXinIM(2)
                 }else if (res.data.data.mode == '4') {
                  this.loginYunXinIM(2)
                 }else if(res.data.data.mode == '5'){
                   this.loginYunXinIM(2)
                   this.addPageViewDatas()
                 }else {
                  this.addPageViewDatas()
                 }
            } else {
              this.errorReport({msg:"getHeartMode调用异常",userinfo:this.fans})
              this.addPageViewDatas()
            }
          })
          .catch((error) =>{
             this.addPageViewDatas()
             this.errorReport({msg:"getHeartMode调用异常",userinfo:this.fans})
          });
    },
    async errorReport(data){
      if (data) {
        data.sessionID = this.pageUUID
      }
      const postData = {
        fans_id:parseInt(this.fans_id || 0),
        error_code:'70000',
        ds_id:parseInt(this.ds_id),
        uid:parseInt(this.uid || 0),
        terminal_type:1,
        data
      }
      // let param = `data=${JSON.stringify(postData)}`
      try {
        await this.axios.post('https://report.tenghuiwangxiao.cn/app/report/errorReport',postData)
      } catch (error) {}
    },
    handlePlaySpeed(val) {
      this.videoSpeed = val;
    },
    heard(time) {
      var that = this;
      if (this.heardTimer) {
        return;
      }
      this.heardTimer = setInterval(() => {
        var option =
          "ds_id=" +
          this.ds_id +
          "&fans_id=" +
          this.fans_id +
          "&cip=" +
          returnCitySN["cip"] +
          "&cname=" +
          returnCitySN["cname"] +
          "&cid=" +
          returnCitySN["cid"] +
          "&uid=" +
          this.uid +
          "&channel_ds_code=" +
          this.channel_id +
          "&terminal_type=1" +
          "&interval=" +
          this.heart_time;
        if (this.tid) {
          option = option + "&tid=" + this.tid;
        }
        that.axios
          .post(tool.baseUrlUser() + "/app/index/heart", option)
          .then((data) => {
            if (data.data.code == 2000) {
              if (this.heart_time != data.data.data.interval) {
                this.heart_time = data.data.data.interval || 30;
                clearInterval(this.heardTimer);
                this.heardTimer = null;
                this.heard(this.heart_time * 1000);
              }
            }
          })
          .catch((data) => {});
      }, this.heart_time * 1000);

      if (this.heardVodTimer) {
        clearInterval(this.heardVodTimer);
        this.heardVodTimer = null;
      }

      this.heardVodTimer = setInterval(() => {
        if (this.playerType == "vod" && this.currentPlayerData) {
          /* 如果是倍速播放，需要保证每5秒的视频时长都需要有心跳记录,假如当前的progress=100，视频是2倍数，则在记录100秒的同时，还需要记录95秒的视频心跳，后台的观看进度才不会断开
           * 小于1倍数的时候，只需要请求一次视频心跳
           * 修改为将记录的心跳秒数改为5的倍数，方便后端统计，假如观看到了103秒，则向下舍去3秒，从第100秒记录，100 95 90 .... 
           */
          let progress = this.currentPlayerData.currentPlayTime
          progress = progress - progress % 5
          let num = this.videoSpeed < 1 ? 1 : Math.ceil(this.videoSpeed)
          while(num > 0) {
            num--
            const recordSecond = Math.floor(progress - num * 5)
            // 如果进度条观看时间不大于0，则不上报心跳
            if(recordSecond <= 0) {
              continue
            }
            const videoData = {
              file_id: this.currentPlayerData.playData.file_id,
              fans_id: this.fans_id,
              uid: this.uid,
              ds_id: this.ds_id,
              progress: recordSecond
            }
            this.axios.post(tool.baseUrlUser() + "/app/index/videoHeart", qs.stringify(videoData))
          }
        }
      }, 5000);
    },
    cutClarity(item) {
      var that = this;
      this.currentTime = this.myPlayer.currentTime;
      this.videoLinkno = item.url;
      this.curClarity = item.clarity;
      this.switchClarity();
      localStorage.setItem("clarity", item.clarityMode);
      this.isShowControl = false;
      // this.myPlayer.load();
      setTimeout(function() {
        that.videoPlay();
      }, 200);
    },
    switchClarity() {
      this.showClarity = !this.showClarity;
    },
    setControl() {},
    update() {
      var playSchedule = document.getElementById("playSchedule");
      var playPoint = document.getElementById("playPoint");
      this.videoCurrentTime = tool.changeTime(this.myPlayer.currentTime);
      var percent = this.myPlayer.currentTime / this.myPlayer.duration;
      playSchedule.style.width = percent * 100 + "%";
      playPoint.style.left = percent * 100 + "%";
    },
    onControlClicked() {
      var that = this;
      that.showClarity = false;
      clearTimeout(this.controlTimer);
      if (this.isShowControl) {
        this.isShowControl = false;
        if (this.scrollDir == "down") {
          this.isRolling = true;
        }
      } else {
        if (this.scrollDir == "down") {
          this.isRolling = false;
        }
        this.isShowControl = true;
        this.controlTimer = setTimeout(function() {
          that.onControlClicked();
        }, 5000);
      }
    },
    onPlayBtnClicked() {
      if (this.myPlayer.paused) {
        this.myPlayer.play();
      } else {
        this.myPlayer.pause();
        this.currentTime = this.myPlayer.currentTime;
      }
    },
    videoPlay() {
      var that = this;
      if (
        (this.videoIndex == 0 && this.directStatus == "end") ||
        this.videoIndex > 0
      ) {
        if (!this.canBack) {
          Toast("直播已结束");
          return false;
        }
      }
      //如果有音乐关闭音乐
      var audio = document.getElementById("audio");
      if (audio) {
        audio.pause();
      }
      // 移除音乐监听
      document.body.removeEventListener("click", this.playmusic);
      that.myPlayer.currentTime = that.currentTime;
      that.myPlayer.play();

      if (this.isIOS) {
      } else {
        if (this.isFirstPlay) {
          //历史播放记录加载
          if (this.currentTime == 0) {
            var time = window.localStorage.getItem(this.videoLinkno);
            if (time > 0) {
              this.currentTime = time;
            }
          }
          //播放
          this.playtimer = setInterval(function() {
            that.myPlayer.play();
            that.myPlayer.currentTime = that.currentTime;
          }, 200);

          var s = this.currentTime;
          if (s != 0) {
            var timer = setInterval(function() {
              that.myPlayer.currentTime = s;
              if (that.myPlayer.currentTime != 0) {
                that.isFirstPlay = false;
                clearInterval(timer);
              }
            }, 500);
          }
        }
      }

      return true;
    },
    initUI() {
      //初始化页面
      var w = document.body.clientWidth;
      var screenH = this.screenH;
      var h = this.noPlayH;
      var contentHeight;
      if (!this.isIOS) {
        this.playerStyle = {
          display: "none",
        };
      }
      if (this.topAD) {
        contentHeight =
          h -
          w * 0.56 -
          44 -
          this.pieceHeight -
          38 -
          this.salesHeight -
          this.bannerHeight;
      } else {
        contentHeight =
          h -
          w * 0.56 -
          44 -
          this.pieceHeight -
          this.salesHeight -
          this.bannerHeight;
      }

      this.contentStyle = {
        height: contentHeight + "px",
      };

      this.isPlayUI = false;
      clearTimeout(this.controlTimer);
      this.isShowControl = true;
      this.showhead = false;
      this.showControl = true;
      this.headtitleBg = "#212126";
      this.showCover = true;
      this.showMenu = true;
      if (this.topAD) {
        this.playHeight = 38;
      } else {
        this.playHeight = 0;
      }
      this.bottomSider = true;
      this.showView = true;
      this.showfunc();
      if (this.ds_func.rolling) {
        this.openRolling = true;
        this.isRolling = true;
      }

      this.loginErrroStyle = {
        display: "block",
        height:
          h -
          w * 0.56 -
          (this.playHeight +
            this.pieceHeight +
            this.salesHeight +
            this.bannerHeight) +
          "px",
      };
    },
    playUI() {
      var w = document.body.clientWidth;
      var screenH = this.screenH;
      var h = this.noPlayH;
      var headerH = 54;
      var that = this;
      this.orientation = "portraint";
      if (!this.isIOS) {
        this.playerStyle = {
          height: screenH + "px",
          width: w + "px",
          objectFit: "contain",
          objectPosition: "top " + headerH + "px left 0px",
          display: "block",
        };
      }

      this.isPlayUI = true;
      //影藏遮盖层
      this.showCover = false;
      if (this.topAD) {
        this.playHeight = 0;
      }
      this.hidefunc();
      this.showControl = true;
      this.isShowControl = false;
      this.onControlClicked();
      this.fullscr = false;
      this.talkred = true;
      this.showView = true;
      this.showMenu = true;
      this.bottomSider = true;
      if (this.isIOS) {
        this.playerStyle = {};
        this.controlStyle = {};
        return false;
      }

      this.controlStyle = {
        height: w * 0.56 + "px",
        top: headerH + "px",
      };
      this.contentStyle = {
        height: screenH - w * 0.56 - 98 - this.pieceHeight + "px",
        display: "block",
      };

      this.playHeight = 54;
      this.showhead = true;
      this.headtitleBg = "#212126";

      this.loginErrroStyle = {
        display: "block",
        height:
          screenH -
          w * 0.56 -
          (this.playHeight +
            this.pieceHeight +
            this.salesHeight +
            this.bannerHeight) +
          "px",
        bottom: 0,
      };
    },
    fullScreenUI() {
      var screenH = window.screen.height;
      var screenW = window.screen.width;
      var that = this;
      this.orientation = "landscape";
      this.fullscr = true;
      this.bottomSider = false;
      this.showView = false;
      this.openRolling = false;
      this.talkred = false;
      this.showMenu = false;
      if (this.isIOS) {
        this.controlStyle = {
          height: "100%",
          width: "100%",
        };
        return false;
      }
      this.playerStyle = {
        height: "100%",
        width: "100%",
        display: "block",
        objectFit: "fill",
      };
      this.controlStyle = {
        height: "100%",
        width: "100%",
        top: "0px",
      };
      this.playHeight = 0;
      this.headtitleBg = "none";
      this.contentStyle = {
        display: "none",
      };
      this.loginErrroStyle = {
        display: "none",
      };
    },
    handleTabClick(item) {
      if (!this.initData.ds_menu.length) {
        return;
      }
      this.curCid = this.initData.ds_menu[item].cid;
      this.currentMid = this.initData.ds_menu[item].mid;
      if (this.curCid == 6) {
        this.dispark = true;
      } else if (this.curCid == 5) {
        if (this.initData.ds_menu[item].config == 1) {
          location.href = this.initData.ds_menu[item].content;
        }
      } else if (this.curCid == 2) {
        this.vid = this.initData.ds_menu[item].config;
      } else if (this.curCid == 9) {
        if (!this.storeActive) {
          this.storeActive = this.initData.ds_menu[item].config;
          this.StoreUrl =
            "http://ph.shikee.tv/store/?ds_id=" +
            this.ds_id +
            "&active=" +
            this.storeActive +
            "#/index";
          console.log(this.StoreUrl);
        }
      } else {
        this.dispark = false;
        this.ripple(100);
      }
    },
    playPause() {
      // rtc播放
      if (!this.isNotShowWebRTC) {
        if (this.rtcRemoteStream) {
          this.rtcLiveResume();
          this.isShowProgress = true;
          this.isPlay = true;
          this.showCover = false;
          this.play = true;
          this.topAD = false;
        } else {
          Toast("老师还没上课，请稍后!");
        }
        return;
      }

      var that = this;
      if (this.playStart) {
        this.myPlayer.play();
        return;
      }
      var start = new Date(this.startTime.replace(/-/g, "/"));
      if (this.directStatus == "not_started" && this.before_ad.length == 0) {
        Toast(
          "直播时间：" +
            (1 + start.getMonth()) +
            "月" +
            start.getDate() +
            "日 " +
            start.getHours() +
            "时" +
            start.getMinutes() +
            "分"
        );
        return;
      }

      if (this.directStatus == "end" && this.canBack) {
        if (this.breakPoint.length < 1) {
          Toast("回放视频正在生成!");
          return;
        } else {
          if (!this.myPlayer.currentTime) {
            Toast("直播已结束，开始播放回放视频");
          }
        }
      }

      if (!this.videoPlay()) {
        return;
      }
      if (!this.fullscr && this.isIOS) {
        this.playUI();
      }
      this.tryUi();
      this.playStart = true;

      console.log("播放方法被执行了:" + this.videoLinkno);
    },
    tryUi() {
      var that = this;
      this.tryOpacity = 1;
      setTimeout(function() {
        if (that.directStatus == "end" || that.videoIndex != 0) {
          that.tryOpacity = 0;
          that.tryPayBtn = true;
        }
      }, 5000);
    },
    shareToWeChat() {
      var that = this;
      var option = 'url=' + encodeURIComponent(location.href) + '&uid=' + this.uid;
      this.axios
        .post(tool.baseUrl2() + "/init/getWechatShareData", option)
        .then(function(data) {
          var data = data.data;
          if (data.code == 200) {
            that.wxReady(data.data.shareData);
          }
        })
        .catch(function(data) {
          console.log("错误" + data);
        });
    },
    wxReady(params) {
      var that = this;

      //配置分享
      wx.config({
        debug: false,
        appId: params.appid, // 必填
        timestamp: params.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.noncestr, // 必填，生成签名的随机串
        signature: params.signature, // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });

      console.log("直播间数据", that.initData);

      this.share.url = params.url;
      this.share.dec = that.initData.direct_seeding.desc;
      this.share.title = that.initData.direct_seeding.name;
      this.share.image = that.initData.direct_seeding.pic_url;
      this.share.groupImage = that.initData.direct_seeding.pic_url;
      this.share.groupDesc = that.initData.direct_seeding.name;

      const funcList = this.initData.ds_func;

      const shareItem = funcList.find((item) => {
        return item.module == "share";
      });

      if (shareItem) {
        this.share.dec = shareItem.params.friend_des;
        this.share.title = shareItem.params.friend_title;
        this.share.image = shareItem.params.friend_pic_url;
        this.share.groupImage = shareItem.params.moment_pic_url;
        this.share.groupDesc = shareItem.params.moment_des;
      }

      console.log("分享参数", this.share, params);

      wx.ready(function() {
        //微信好友分享
        wx.updateAppMessageShareData({
          title: that.share.title, // 分享标题
          desc: that.share.dec, // 分享描述
          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
          imgUrl: that.share.image, // 分享图标
          success: function() {
            console.log("设置分享微信好友分享参数成功");
          },
        });

        //微信朋友圈分享
        wx.updateTimelineShareData({
          title: that.share.groupDesc, // 分享标题
          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
          imgUrl: that.share.groupImage, // 分享图标
          success: function() {
            console.log("设置分享微信朋友圈分享参数成功");
          },
        });
      });
      wx.error(function(data) {
        console.log("错误");
        console.log(data);
      });
    },
    getshare() {
      var that = this;
      var url = tool.baseUrl() + "/fans/share/index";

      var option = {
        fans_id: that.fans_id,
        ds_id: that.ds_id,
      };

      option = tool.encrypt(option);
      that.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == 200) {
            that.rewardType = 2;
            that.rewardredpack = true;
            that.shareRedexist = false;
            that.rewardMoney = data.data.money;
          } else {
            Toast(data.message);
            that.shareRedexist = false;
          }
        })
        .catch(function(res) {
          console.log("获取分享数据失败失败" + res);
        });
    },
    getshareQuan() {
      var that = this;
      var url = tool.baseUrl2() + "/share/coupon";

      var option = {
        fans_id: that.fans_id,
        ds_id: that.ds_id,
      };

      option = tool.encrypt(option);
      that.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == 200) {
            that.rewardType = 2;
            that.rewardQuan = true;
            that.shareRedexist = false;
            that.quanData = data.data;
          } else {
            Toast(data.message);
            that.shareRedexist = false;
          }
        })
        .catch(function(res) {
          console.log("获取分享数据失败失败" + res);
        });
    },
    livestart(json) {
      var message;
      if (json.module == "ds_start") {
        var timesecond = 0;
        if (json.delay_status) {
          timesecond = json.delay_time * 1000;
        } else {
          timesecond = 0;
        }

        setTimeout(function() {
          message = "直播已经开始，点击播放";
          Dialog.alert({
            title: "温馨提示",
            message: message,
          }).then(() => {
            window.location.reload();
          });
        }, timesecond);
      } else {
        message = "直播已经结束";
        Dialog.alert({
          title: "温馨提示",
          message: message,
        }).then(() => {
          window.location.reload();
        });
      }
    },
    personnum(numValue) {
      //增加观看人数
      // if (numValue == "0") {
      //   this.view_num++;
      // } else {
      //   if (this.view_num < numValue) {
      //     this.view_num = numValue;
      //   }
      // }
    },
    timestamps() {
      var time = new Date();
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();

      return (
        "" +
        y +
        tool.two(m) +
        tool.two(d) +
        tool.two(h) +
        tool.two(mm) +
        tool.two(s)
      );
    },
    swichWindow() {
      this.forbid = !this.forbid;
      localStorage.setItem("forbid", this.forbid);
    },
    playBack() {
      var that = this;
      var url = tool.baseUrl2() + "/playback/index";
      var option = "uid=" + this.uid + "&ds_id=" + this.ds_id;
      this.axios
        .post(url, option)
        .then(function(data) {
          var data = data.data;
          if (data.code == 200) {
            that.canBack = true;
          } else {
            that.canBack = false;
            console.log(data.message);
          }
        })
        .catch(function(data) {
          //Toast(data);
        });
    },
    closeAD() {
      this.topAD = false;
      this.initUI();
    },
    loginIM(noShowToast) {
      if (this.initData.direct_seeding.im_type == 2) { //网易IM
        this.loginYunXinIM(1)
      }else { 
        if (!noShowToast) {
          Toast.loading();
        }
        var option = "fans_id=" + this.fans_id;
        this.axios.post(tool.baseUrl1() + "/api/im/getUserSign",option).then((res)=> {
          localStorage.setItem("tl_sign",res.data.data.tl_sign)
          this.loginIMToDo(res.data.data.tl_sign)
        }).catch((error) =>{
          this.axios
            .post("https://service-r0p4y9rc-1258158934.gz.apigw.tencentcs.com/release/api/login/getImUserSign", option)
            .then((res)=> {
              localStorage.setItem("tl_sign",res.data.data)
              this.loginIMToDo(res.data.data)
            })
            .catch((error) =>{
            });
        });
      }
	   this.$wsClient.connect({ userId: this.fans_id ,terminal: "live_h5"  });
    },
	domainMiniProgrameReport(){
		//上报域名小程序
		let params = `type=1&url=https://${window.location.hostname}&fans_id=${this.fans_id}&uid=${this.uid}`
		if (tool.isWeixinMP()) {
		//从 userAgent 中提取小程序 appid
		const ua = window.navigator.userAgent || ""
		const match = ua.match(/miniProgram\/([\w-]+)/i)
		const appid = match ? match[1] : ""
		params = `type=2&appid=${appid}&fans_id=${this.fans_id}&uid=${this.uid}`
		}
		this.axios.post(`${tool.baseUrl1()}/api/fansIndex/fansinOrg`, params);
	},
    loginIMToDo(tl_sign){
      var that = this;
      var obj = {};
          obj["currentGroupId"] = that.initData.direct_seeding.room_id;
          // obj["currentGroupId"] = '@TGS#aOYDEPXMX'
          obj["identifier"] = this.fans_id;
          obj["identifierNick"] = that.fans.nick;
          obj["headurl"] = that.fans.header;
          obj["userSig"] = tl_sign;
          //腾讯IM登录
          handleIm.loginIM(obj,1,{
            setMsgListener:this.onReceivedMsgCallBack,
            setMemberMsgListener:this.onReceivedP2PMsgCallback,
            setImStatusListener:this.imStatusListener
          })
    },
    onReceivedP2PMsgCallback(json) {
      this.$refs.consultTeacher.receivedMsg(json);
      if (!this.showConsultTeacher) {
        // this.$refs.chat[0].receivedMsg(json);
        // this.$refs.chat[0].showUnReadViewFunc(json);
      }
    },
    loadFakeComment() {
      const self = this;
      // 获取服务器时间校准
      var url = tool.baseUrl1() + "/wap/live/getServerTime";
      var option = "";
      this.axios
        .post(url, option)
        .then(function(data) {
          if (data.data.code == 200) {
            const time = data.data.data.time;
            let real_start_time =
              (self.initData.direct_seeding.real_start_time &&
                self.initData.direct_seeding.real_start_time.replace(
                  /-/g,
                  "/"
                )) ||
              self.initData.direct_seeding.start_time;
            let tempTime =
              new Date(real_start_time).valueOf() +
              new Date().valueOf() -
              new Date(time.replace(/-/g, "/")).valueOf();
            const startTime = self.getTimes(tempTime);
            console.log(
              "时间校准",
              data.data.data.time,
              self.getTimes(new Date().valueOf())
            );
            const tid = self.initData.fakeTemplateId;
            FakeIm.setCommentCallback(self.onReceivedMsgCallBack);
            console.log("校准后时间:", startTime);
            FakeIm.startLoad(startTime, tid, (isOK) => {
              if (isOK) {
                FakeIm.startCommentRun();
              } else {
                Toast("获取评论失败，请刷新重试");
              }
            });
          } else {
            Toast("网络错误" + data.data.message);
          }
        })
        .catch(function(data) {
          console.log("时间校准错误", data);
          Toast("网络错误" + data);
        });
    },
    getNot() {
      var that = this;
      // im.getNotification(function(data) {
      //   if (data != false && data != null) {
      //     console.log("动态秘钥：" + data.Notification);
      //     vxxData.verifyCode = data.Notification;
      //   } else {
      //     var flag = confirm("获取聊天动态秘钥失败");
      //     if (flag) {
      //       that.getNot();
      //     } else {
      //       that.getNot();
      //     }
      //   }
      // });
    },
    ripple(num) {
      var that = this;
      if (that.shopIndex < 0) {
        return;
      }
      setTimeout(function() {
        document.querySelectorAll(".van-tab")[that.shopIndex].className =
          "van-tab ripple";
      }, num);
    },
    robRedBagAction(item) {
      //抢红包
      var that = this;
      if (!this.isWeixin) {
        return;
      }
      if (this.isGradRedStart) {
        return;
      }
      this.redBagData = item;
      this.isGradRedStart = true;
      var url = tool.baseUrl() + "/redPacket/Grab/index";
      var option = {
        fans_id: this.fans_id,
        msg_id: item._id,
      };

      option = tool.encrypt(option);

      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == 200) {
            that.redBaglistData = data.data;
            if (data.data.status == "is_open") {
              that.showrobRedlist = true;
            } else if (data.data.status == "is_close") {
              that.showrobRedlist = true;
            } else {
              Toast("抢红包失败！稍后再试！");
            }
          }
          that.isGradRedStart = false;
        })
        .catch(function(res) {
          that.isGradRedStart = false;
          Toast("抢红包失败！稍后再试！");
          console.log(res);
        });
    },
    closeRodRedList() {
      this.showrobRedlist = false;
    },
    switchSider() {
      this.bottomSider = !this.bottomSider;
      this.shareRed = !this.shareRed;
      this.talkred = !this.talkred;
    },
    getTimes(timeStr) {
      var time = new Date();
      if (timeStr) {
        time = new Date(timeStr);
      }
      var year = time.getFullYear();
      var month = tool.two(time.getMonth() + 1);
      var date = tool.two(time.getDate());
      var hours = tool.two(time.getHours());
      var minutes = tool.two(time.getMinutes());
      var seconds = tool.two(time.getSeconds());

      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    onReceivedMsgCallBack(json) {
      console.error("json", json);

      var that = this;
      // console.log(JSON.stringify(json));
      if (!json.create_time) {
        json.create_time = this.getTimes();
      }
      switch (json["module"]) {
        case "shopping_cart": //是否显示购物车
          if (json.status == "yes") {
            this.isshowCart = true;
            const data = JSON.parse(json.params)
            if(data.length > 0) {
              const { type, shangpingID } = data[0]
              if(type === '3') {
                this.showShoppingType = false
                this.showShoppingDialog = true
              } else if(type === '2') {
                this.showShoppingType = true
                this.showShoppingDialog = false
              }
              if(type !== '1') {
                // 二、三购物车样式只会有一个商品信息
                this.goodsInfo = shangpingID[0]
                this.goodsIdsList = [this.goodsInfo.id]
              } else {
                // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
                this.goodsInfo = {}
                this.goodsIdsList = shangpingID
              }
            }
          } else {
            this.isshowCart = false
            this.goodsIdsList = []
            this.showShoppingType = false
            this.showShoppingDialog = false
          }
          break;
        case "red_rain_close": //红包雨结束
          that.$refs.redrain.redbagRain(json);
          break;
        case "rain_random": //红包雨随机
          this.rainProbab = json.percent;
          this.rainId = json.id;
          setTimeout(function() {
            that.$refs.redrain.redbagRain(json);
          }, 300);
          break;
        case "rain_normal": //红包雨
          this.rainProbab = json.percent;
          this.rainId = json.id;
          setTimeout(function() {
            that.$refs.redrain.redbagRain(json);
          }, 300);
          break;
        case "ds_start": //直播开始了
          this.livestart(json);
          break;
        case "ds_end": //直播结束了
          this.livestart(json);
          break;
        case "delete_comment": //删除评论
          this.$refs.chat.deleteComment(json);
          break;
        case "text_comment": //文字评论
          this.$refs.chat.textComment(json);
          break;
        case "gift_comment": //礼物打赏
          this.$refs.toolbar.gift(json);
          this.$refs.chat.giftComment(json);
          break;
        case "share_red_pack_end": //分享红包结束
          this.shareredend();
          break;
        case "red_password_end": //口令红包结束
          this.talkredend();
          break;
        case "update_verify_code": //更新秘钥
          vxxData.verifyCode = json.content.verify;
          break;
        case "agreeLink": //老师邀请连麦
          this.linkLive(json);
          break;
        case "linkDown":
          this.linkDown(json);
          break;
        case "system_message_group_introduction": //群公告
          {
            if (json.content && json.content.online_num != undefined) {
              this.view_num = json.content.online_num;
            }
          }
          break;
        case "system_message_group_notification": //群通知
          // let content = JSON.parse(json.content);
          // if (content.showConsultTeacher != undefined) {
          //   //咨询老师
          //   this.$refs.chat[0].showConsultTeacher(content);
          // }
          break;
        case "wx_follow_change": //是否显示二维码
          this.isShowQRimg = json.params.wx_show_now == "yes";
          this.openWx_follow = json.params.wx_show_now == "yes";

          if (this.isShowQRimg) {
            setTimeout(() => {
              this.isShowQRimg = false;
            }, 5000);
          }

          break;
        case "PERSON_IN_BLACK":
          console.log(json.fans_id_list, this.fans_id, "黑名单");
          if (json.fans_id_list.indexOf(`${this.fans_id}`) > -1) {
            if (json.in_black == "yes") {
              this.isBlack = true;
              clearInterval(this.heardTimer);
              this.heardTimer = null;
              location.reload();
            } else {
              location.reload();
              this.isBlack = false;
            }
          }
          break;
        case "PERSON_KICK_OUT":
          if (json.fans_id == this.fans_id) {
            window.location.href = json.to_web;
          }
          break;
        case "screenCaptureChange":
          console.log("需要刷新播放器");
          setTimeout(() => {
            this.$refs.tfPlayer.playVideoClicked();
          }, 500);
          break;
        case "GIFT_CHANGE_STATUS": //送花点赞
          if (json.status == "yes") {
            this.isshowgift = true;
          } else {
            this.isshowgift = false;
          }
          break;
        case "CONSULTING_TEACHER_STATUS": //是否显示联系老师
          // if (json.status == "yes") {
          //   this.showTeacherBtn = true;
          // } else {
          //   this.showTeacherBtn = false;
          // }
          break;
        case "comment_on_off": //全员静言
          {
            this.is_all_users_muted = json.status == "0";
          }
          break;
        case "show_teacher_qrcode": //是否显示老师二维码
          {
            if (json.open == 1) {
              this.isShowTeacherQrCode = true;
              this.isShowTeacherBtnTop = false;
              if (this.$refs.tfPlayer.getPlayerIsfullScreen()) {
                if (this.isIOS) {
                  window.location.reload();
                } else {
                  this.$refs.tfPlayer.exitFullScreen();
                }
              }
            } else {
              this.isShowTeacherQrCode = false;
              this.isShowTeacherBtnTop = false;
            }
            this.teacher_qrcode_title = json.title || "";
            this.teacher_qrcode_url = json.image || "";
          }
          break;
        case "say_self": //自嗨消息
          {
            this.say_self = {
              enabled: json.status == "yes", 
              type: json.params.type,
              all: json.params.all,
            };
          }
          break;
        case "notice": //公告
          {
            this.noticeObj = {
              open: json.status == "yes",
              content: json.params.content,
              time: json.params.time,
            };
          }
          break;
          // 正在购买
        case 'shopping_purchase':
          this.saveUserBuyList.push(json.nick)
          if(!this.tipsBuyTimer) {
            this.showTipsByUserBuy()
          }
          break;
        // 购买成功
        case 'shopping_success':
          this.saveUserBuySuccessList.push(json.nick_name)
          this.inventoryNum = json.num
          if(!this.tipsBuySuccessTimer) {
            this.showTipsByUserBuySuccess()
          }
          break;
        // 购买提示
        case 'purchase_prompt':
          this.showBuyTipsState = json.status === 'yes'
          break;
        case 'verify_comment': //评论审核
          {
            this.verify_comment = json.status == 'yes';
          }
          break;
        case "ds_refresh": //刷新直播间
        {
            setTimeout(() => {
              location.reload()
            }, Math.round(Math.random() * 10) * 1000);
        }
        break;
        case "system_message_broadcast": // 全员广播消息
        {
          if (json.content.type == "emergency_mode"){ // 紧急模式
              if (json.content.status == "off"){
                window.isExceptionMode = false;
                console.log("关闭紧急模式");
                //随机120秒内刷新页面
                if (this.fans && this.fans.is_exception_mode) {
                    let refreshTime = Math.floor(Math.random() * 120) * 1000;
                    setTimeout(() => {
                        if (this.userOrgConfigData.official_account_appid) {
                          localStorage.removeItem(this.userOrgConfigData.official_account_appid);
                          localStorage.removeItem("current_app_Id");
                          tool.delCookie('netschool_token')
                          localStorage.removeItem("yhj_token");
                        }
                      window.location.reload();
                    }, refreshTime);
                }
              } else if (json.content.status == "on"){
                window.isExceptionMode = true;
                console.log("开启紧急模式");
              }
          }
        }
        break;
        default:
          //this.$refs.chat[0].addReviewWrap(json);
          break;
      }
    },
    imStatusListener(resp) {
      if (resp.ErrorCode == 1) {
        //网络恢复，需要重新连接
        Toast("网络恢复正在重新连接聊天室...");
        if (
          this.playerStatus == 2 &&
          this.initData.direct_seeding.play_style == "3"
        ) {
          if (this.outOfTime == 2 && this.linkType == 3) {
            // 连麦操作
            this.$refs.tfPlayer.rtcLiveLeave(() => {
              this.$refs.tfPlayer.rtcLink();
            });
          } else {
            this.linkType = 1;
            this.$refs.tfPlayer.rtcLiveLeave(() => {
              this.$refs.tfPlayer.playVideoClicked();
            });
          }
        }
        return;
      }

      if (resp.ErrorCode == 9999) {
        //网络断开了
        Toast("聊天室网络中断，将无法收到消息，请检查网络或刷新页面");
      }
    },
    buyProduct(json) {
      var that = this;
      this.buyList.push(json);
      setTimeout(function() {
        that.buyListIndex++;
      }, 6000);
    },
    tryPay() {
      tool.bugTicket(this.coupon_id, this.payLoad);
    },
    select(index, id) {
      this.payIndex = index;
      this.coupon_id = id;
    },
    payCancel() {
      this.showPay = false;
      this.myPlayer.play();
    },
    onShowPay() {
      if (this.ticket_switch) {
        Toast.loading();
        tool.getCoupon(this.getCoupon);
      } else {
        this.showPay = true;
      }
      console.log(this.coupons);
    },
    getCoupon(coupons) {
      Toast.clear();
      this.coupons = coupons;
      console.log(this.coupons.length);
      this.showPay = true;
    },
    payLoad() {
      var that = this;
      sessionStorage.setItem("initData", null);
      setTimeout(function() {
        that.$router.replace("/home");
        window.location.reload();
      }, 2000);
    },
    onShowAllot() {
      var that = this;
      this.showAllot = true;
      if (!this.headerData) {
        this.getHeadImg();
      }
      if (!this.code) {
        var qrcodeurl =
          "http://u.tenghuiwangxiao.cn/?ds_id=" +
          this.ds_id +
          "#/home/" +
          this.fans_id;
        const qrcoder = new QRCoder({
          data: qrcodeurl,
          size: 240,
        });
        this.code = qrcoder.getDataURL();
      }
      if (!this.base64Img) {
        this.getBase64(this.initData.direct_seeding.pic_url);
      }
      console.log(this.canvas);
      if (!this.canvas) {
        var timer = setInterval(function() {
          if (that.headerData && that.code && that.base64Img) {
            clearInterval(timer);
            html2canvas(document.querySelector("#shareCard"), {
              useCORS: true,
              allowTaint: true,
              taintTest: true,
              backgroundColor: "transparent",
            }).then((canvas) => {
              console.log(canvas);
              that.canvas = canvas.toDataURL("image/png");
              Toast.clear();
            });
          }
        }, 100);
      }
    },
    onCloseAllot() {
      this.showAllot = false;
    },
    getHeadImg() {
      var that = this;
      var option;
      Toast.loading();
      option = "fans_id=" + this.fans_id;
      this.axios
        .post(tool.baseUrl() + "/fans/invite/getImg", option)
        .then(function(res) {
          that.headerData = res.data;
          console.log(that.headerData);
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    getBase64(url) {
      var that = this;
      this.axios
        .post(
          "http://plive.shikee.tv/fans/invite/shareCardImage",
          "url=" + encodeURIComponent(url)
        )
        .then(function(data) {
          that.base64Img = data.data;
          console.log(that.base64Img);
          console.log(data.data);
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    registerOk() {
      this.registerViewShow = false;
    },
    whiteNumOk() {
      console.log("执行成功！！！！！！！！！！");
      this.TelTestShow = false;
      //开启白名单 //地理位置上报
      this.isWeixinUserCheck((isSuccess)=>{
          isSuccess && this.getHeartMode();
      })
     
    },
    linkAccept() {
      if (this.linkType === 1) {
        console.log("发送连麦消息");
        handleIm.sendApplyLink();
      } else if (this.linkType === 2) {
        handleIm.sendSureLink();
        //开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
      } else if (this.linkType === 3) {
        //走结束连麦流程
        this.$refs.tfPlayer.rtcLinkDown();
        this.linkType = 1;
         //切换快直播播放
        this.$refs.tfPlayer.changePlayType(3);
      }
      this.linkDialogVisible = false;
    },
    linkRefuse() {
      console.log("拒绝连麦");
      if (this.linkType === 2) {
        handleIm.sendRefuseLink();
      }
      this.linkDialogVisible = false;
    },
    linkLive(data) {
      if (this.initData.direct_seeding.play_style != 2) {
        return;
      }

      if (data.content == this.fans_id) {
        const canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
        if (!canLink) {
          handleIm.sendCannotLink("1");
          return;
        }
        this.linkType = 2;
        this.linkDialogVisible = true;
      }
    },
    linkDown(data) {
      if (data.content == this.fans_id) {
        //需要下麦操作
        this.$refs.tfPlayer.rtcLinkDown();
         //切换快直播播放
        this.$refs.tfPlayer.changePlayType(3);
      }
    },
  },
};
</script>

<style  scoped>
@import "../../../../statics/css/comment.scss";

.tosafari {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: 3000;
}

.tosafari .content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tosafari .content img {
  width: 100%;
  flex: 1;
  height: 0px;
}

.tosafari .content .bottom {
  height: 50px;
  width: 100%;
  background-color: #d3d3d3;
  text-align: center;
}

.tosafari .content .bottom button {
  width: 100%;
  line-height: 50px;
  border: none;
}

.van-popup.iosPosition {
  position: absolute;
}

.player {
  position:absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.height25 {
  height: 25px;
}

.menu .van-tab {
  /* font-size: 16px;
   font-weight: 700; */
}

.menu .van-tab--active {
  color: #1483ff;
  position: relative;
}

.menu .van-tabs__line {
  background-color: #1483ff;
  color: #1483ff;
  height: 2px;
}

.van-tabs--line .van-tabs__wrap {
  height: 44px;
  /* margin-right: 62.5px; */
  margin-left: 44px;
}

.hidefouce .van-tabs--line .van-tabs__wrap {
  margin-right: 0px !important;
}

.noline .van-tabs--line .van-tabs__wrap {
  height: 44px;
  /* width: calc(100% - 62.5px); */
  /* margin-right: 62.5px; */
  margin-left: 0px;
}

.menu2 .van-tab--active {
  color: #e5bc4b;
}

.menu2 .van-tabs__line {
  background: #e5bc4b;
  color: #e5bc4b;
}

.menu3 .van-tab--active {
  color: #ec1a1a;
}

.menu3 .van-tabs__line {
  background: #ec1a1a;
  color: #ec1a1a;
}

.Vote .van-tabs__wrap {
  border-radius: 5px;
  overflow: hidden;
}

.Vote .van-tab--active {
  background: #dcb45a;
  color: #fff;
}

.Vote .van-tabs__line {
  background: none;
}

.Vote .van-tabs__line:after {
  border-width: 0;
}

.view_num {
  position: absolute;
  left: 10px;
  top: 26px;
  border-radius: 10px;
  padding: 0 10px;
  height: 20px;
  line-height: 21px;
  color: white;
  font-size: 13px;
  background-color: rgba(20, 19, 19, 0.67);
  z-index: 1000;
}

.view_num img {
  width: 16px;
  vertical-align: middle;
}

.scrollbar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1250;
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
  height: 20px;
  line-height: 20px;
}

.scrollbar p {
  animation: scroll 24s linear infinite;
  white-space: nowrap;
  display: inline-block;
}

@keyframes scroll {
  0% {
    transform: translateX(100vw);
  }

  100% {
    transform: translateX(-100%);
  }
}

.scrollbar a {
  color: #0dff0a;
}

.headtitle {
  position: absolute;
  height: 54px;
  width: 100%;
  background: #212126;
  top: 0px;
}

.headtitle p {
  margin: auto;
  text-align: center;
  padding: 0 15%;
  height: 54px;
  color: white;
  line-height: 54px;
}

.home-content {
  background: #eee;
  width: 100%;
  position: absolute;
  z-index: 1400;
}

.home-content > div {
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  height: 100%;
  scroll-behavior: smooth;
}

.control {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 0px;
  z-index: 1200;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
}

#midControl {
  flex: 1;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
}

#midControl span {
  color: #ffffff;
  font-size: 10px;
  line-height: 42px;
}

#progressWrap {
  position: relative;
  flex: 1;
  margin: 0 16px 0 4px;
}

#playLine {
  position: absolute;
  height: 2px;
  width: 100%;
  background-color: #f5f5f5;
  top: 19px;
  margin-left: 6px;
}

#playSchedule {
  position: absolute;
  height: 2px;
  width: 20%;
  background-color: #1296db;
  top: 19px;
  margin-left: 6px;
}

#playPoint {
  position: absolute;
  background-color: #ffffff;
  width: 0px;
  height: 0px;
  border-radius: 6px;
  top: 14px;
  left: 0px;
  border: 6px solid #fff;
}

.fullSrceenBtn,
.playpause {
  width: 40px;
  text-align: center;
  line-height: 40px;
}

.fullSrceenBtn img,
.playpause img {
  vertical-align: middle;
  width: 20px;
}

.shareRed {
  position: absolute;
  top: 45vw;
  background: rgb(255, 42, 0);
  color: #fff;
  text-align: center;
  padding: 0 10px;
  line-height: 20px;
  right: 10px;
  border-radius: 10px;
  font-size: 12px;
  z-index: 1200;
}

.sharebao {
  margin: -10px;
  background: #fff;
  border-radius: 10px;
  position: relative;
}

.sharebao .gold {
  position: absolute;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0 0 10px 1px #fff;
  top: -28px;
  left: 50%;
  margin-left: -28px;
}

.sharehead {
  padding: 15px 10px;
  overflow: hidden;
  border-radius: 10px;
  line-height: 24px;
  background-color: #de3041;
  background-repeat: no-repeat;
  background-position: center bottom;
  text-align: center;
  color: #fff;
  background-size: 100% auto;
}

.sharehead .loll {
  color: #f8be41;
}

.sharebody {
  padding: 10px;
  color: #7a7a7a;
  text-align: center;
  line-height: 30px;
}

.sharebody .money {
  color: #c32938;
  font-size: 24px;
}

.sharebody .money span {
  font-size: 14px;
  color: #333333;
}

.sharebody .button {
  line-height: 32px;
  font-size: 16px;
  background: #de3041;
  color: #fff;
  border-radius: 16px;
  text-align: center;
  margin: 10px auto;
  width: 160px;
  display: block;
}

.talktext {
  width: 80%;
  border: 1px dashed #c32938;
  border-radius: 5px;
  margin: 20px auto 10px;
  padding: 10px;
  text-align: center;
  color: #c32938;
  font-size: 16px;
}

.playPause {
  position: absolute;
  width: 80px;
  left: 50%;
  transform: translate(-40px, -40px);
  top: 28vw;
  z-index: 1300;
  opacity: 0.7;
}

.music {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 32px;
  height: 32px;
  border-radius: 20px;
  z-index: 1030;
}

.musicPlay {
  animation: swing 1s ease-in-out infinite;
}

.music img {
  display: block;
}

@keyframes swing {
  0% {
    transform: rotate(10deg);
  }

  50% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(10deg);
  }
}

.talkred {
  position: absolute;
  top: 20vw;
  right: 0;
  z-index: 1200;
  height: 50px;
  width: 50px;
}

.talkred img {
  width: 100%;
}

.controlbox {
  position: absolute;
  z-index: 200;
  width: 100%;
  height: 56vw;
  top: 0;
  left: 0;
}

.menu {
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 44px;
  top: 56vw;
}

.close {
  position: absolute;
  top: 15px;
  right: 15px;
  height: 20px;
  width: 20px;
}

.close img {
  width: 100%;
}

.fullBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2000;
}

a.bigTable img {
  width: 100%;
}

.clarity {
  width: 40px;
  position: relative;
  text-align: center;
  color: #fff;
  font-size: 12px;
}

.clarity .cur {
  display: block;
  height: 20px;
  width: 80%;
  line-height: 20px;
  border: 1px solid #eee;
  border-radius: 3px;
  margin: 10px auto;
}

.clarity ul {
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.clarity li {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #eee;
}

.clarity li:last-child {
  border: none;
}

.clarity li.active {
  color: yellow;
}

.clarity.ios {
  position: absolute;
  top: 6px;
  right: 70px;
  z-index: 1300;
  height: 30px;
  background: rgba(51, 51, 51, 0.67);
  line-height: 30px;
  border-radius: 5px;
}

.clarity.ios a {
  margin: 0 auto;
}

.clarity.ios .cur {
  width: 100%;
  height: 30px;
  line-height: 30px;
  border: none;
}

.clarity.ios ul {
  bottom: auto;
  top: 32px;
  border-radius: 5px;
  overflow: hidden;
}

.iosfull {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
}

.videoMusk {
  position: fixed;
  z-index: 9000;
  background: #333;
  height: 100%;
  width: 100%;
}

.window {
  position: absolute;
  top: 36vw;
  right: 0;
  padding: 5px 7px;
  background: rgba(30, 30, 30, 0.4);
  z-index: 1200;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.window img {
  width: 30px;
  vertical-align: middle;
}

.msg_conent p img {
  vertical-align: middle;
}

.floatBox {
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 600;
}

.rightFunction{
  bottom: 80px;
  right: 10px;
  position: fixed;
  z-index: 600;
}

.rightFunction .rightfuncImage{
   width: 40px;
   height: 40px;
   display: block;
}

.ripple {
  background: #e94c69
    url(https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/home/ripple_5.gif)
    no-repeat center center !important;
  -webkit-background-size: 100% auto !important;
  background-size: 100% auto !important;
  color: #fff !important;
}

.comment-text p img {
  vertical-align: middle;
}

.tabs_title .btn {
  display: inline-block;
  width: 48%;
  text-align: center;
}

.tabs_title .btn a {
  line-height: 30px;
  font-size: 15px;
  padding-bottom: 5px;
}

.tabs_title .btn.cur a {
  color: rgb(250, 64, 83);
  border-bottom: 1px solid rgb(250, 64, 83);
}

.trySee {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  z-index: 1020;
  transition: 0.5s;
  opacity: 0;
}

.tryPay {
  position: absolute;
  right: 45px;
  top: 7px;
  padding: 0 10px;
  height: 20px;
  z-index: 1020;
  background: #ff2a00;
  color: #fff;
  border-radius: 10px;
}

.tryBox {
  text-align: center;
}

.tryBox .money {
  color: #ff2a00;
  font-size: 28px;
}

.tryBox .moneyIcon {
  color: #ff2a00;
}

.tryBox .oldMoney {
  color: #999;
  text-decoration: line-through;
  margin-left: 5px;
}

.paydialog .title {
  color: #2c2c2c;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
}

.coupons {
  padding: 10px 10px 10px 100px;
  line-height: 30px;
  max-height: 180px;
  overflow: scroll;
}

.coupons li i {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #999;
  border-radius: 50%;
  position: relative;
  vertical-align: middle;
  margin-right: 5px;
}

.coupons li span {
  display: inline-block;
  vertical-align: middle;
}

.coupons li.cur {
  color: #3e78fb;
}

.coupons li.cur i {
  background: #3e78fb;
  border-color: #3e78fb;
}

.coupons li.cur i:after {
  position: absolute;
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  background: #3e78fb;
  border: 2px solid #fff;
  top: 0;
  left: 0;
  border-radius: 50%;
}

.twobtn {
  height: 50px;
  line-height: 50px;
  display: flex;
  border-top: 1px solid #eee;
}

.twobtn a {
  flex: 1;
  text-align: center;
  color: #2c2c2c;
  font-size: 16px;
}

.twobtn .cancel {
  border-right: 1px solid #eee;
}

.twobtn .sure {
  color: #3e78fb;
}

.explain {
  text-align: center;
  color: #999;
  line-height: 40px;
}

.occupy .addimg .container .moxie-shim {
  width: 100px !important;
  height: 100px !important;
}

.allot_btn {
  position: absolute;
  top: 42px;
  right: 0;
  height: 22px;
  line-height: 22px;
  padding: 4px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  background: rgb(173, 147, 92);
  color: #fff;
  z-index: 1300;
  text-align: center;
}

.allot_btn span:first-child {
  border: 1px solid #fff;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
}

.shareCard {
  padding: 18px;
  background: linear-gradient(#dfd0bd, #ffffff);
  border-radius: 10px;
  overflow: hidden;
}

.boxCloseBtn {
  position: absolute;
  top: 10px;
  right: 14px;
  font-size: 30px;
}

#LiveHotel .showTeacherBtnTop {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9999;
}

#LiveHotel .showTeacherBtnTop img {
  width: 30px;
}

.allot_pic {
  box-shadow: 0 4px 10px #efd6af;
}

.allot_title {
  font-size: 15px;
  color: #191919;
  font-weight: bold;
  line-height: 24px;
  margin-top: 10px;
  max-height: 48px;
  overflow: hidden;
}

.allot_title span {
  display: inline-block;
  background: #c49c5f;
  color: #fff;
  height: 16px;
  line-height: 17px;
  text-align: center;
  border-radius: 8px;
  vertical-align: middle;
  padding: 0 8px;
  font-size: 10px;
  word-break: keep-all;
  margin-left: 5px;
}

.allot_price {
  color: #c49c5f;
  font-size: 25px;
  margin-left: -2px;
}

.allot_price span {
  font-size: 18px;
}

.allot_ul {
  font-size: 12px;
}

.allot_ul span {
  display: inline-block;
  width: 1px;
  height: 13px;
  background: #666666;
  vertical-align: middle;
  margin: 0 10px;
}

.allot_dashed {
  text-align: center;
  margin-top: 30px;
  position: relative;
  height: 20px;
  line-height: 20px;
}

.allot_dasheds {
  height: 20px;
  width: 100%;
  overflow: hidden;
}

.allot_dashed span {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #dcc9b0;
  margin: 0 5px;
  vertical-align: middle;
}

.allot_dashed:before,
.allot_dashed:after {
  position: absolute;
  content: "";
  display: block;
  top: 0px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(90deg, #303030, #303030);
}

.allot_dashed:before {
  left: -32px;
}

.allot_dashed:after {
  right: -32px;
}

.allot .userInfo {
  padding: 15px 0;
}

.allot .userInfo .userImg {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
  margin-top: 7px;
}

.allot .userInfo .name {
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
  color: #666666;
}

.allot .userInfo .colors {
  color: #c49c5f;
}

.allot .code {
  width: 60px;
  height: 60px;
  margin-right: 6px;
  overflow: hidden;
}

.allot .copyRight {
  text-align: center;
  color: #c49c5f;
  font-size: 10px;
  height: 20px;
  line-height: 20px;
}

.allot .copyRight span {
  position: relative;
  display: inline-block;
}

.allot .copyRight span:before,
.allot .copyRight span:after {
  position: absolute;
  display: block;
  content: "";
  top: 8px;
  width: 40px;
  height: 1px;
  background: #c49c5f;
}

.allot .copyRight span:before {
  left: -50px;
}

.allot .copyRight span:after {
  right: -50px;
}

.allot_tip {
  position: absolute;
  top: 50%;
  margin-top: 240px;
  color: #fff;
  text-align: center;
  width: 100%;
  font-size: 16px;
}

.allot_canvas {
}

/*选择学校弹框*/
.schooldialog {
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  padding: 0 21px;
  padding-bottom: 37px;
}

.schooldialog .title {
  font-size: 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding: 0 0 0 20px;
}

.el-input__inner {
  margin-top: 16px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 20px;
  border: 1px solid #bfbfbf;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.select-down {
  position: absolute;
  top: 80px;
  left: 10px;
  right: 10px;
  z-index: 1000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 15px 0px rgba(136, 148, 189, 0.31);
  border-radius: 16px;
  max-height: 250px;
  overflow: scroll;
}

.select-down li {
  padding: 10px 19px;
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
}

.select-down li:active {
  background: #f2f4fb;
}

.shoolsureBtn {
  margin-top: 33px;
  background: linear-gradient(
    104deg,
    rgba(0, 206, 252, 1),
    rgba(0, 138, 249, 1)
  );
  box-shadow: 0px 4px 11px 0px rgba(0, 127, 204, 0.31);
  border-radius: 20px;
  text-indent: none;
  border: none;
  display: block;
  width: 100%;
  color: #ffffff;
  height: 40px;
}

.banner {
  height: 67px;
  overflow: hidden;
  width: 100%;
  position: absolute;
  z-index: 1000;
  width: 100%;
  top: 56vw;
}

.banner a {
  width: 100%;
  height: 100%;
  display: block;
}

.banner img {
  width: 100%;
  height: 67px;
  display: block;
}

.rightFocus {
  position: absolute;
  top: 0;
  right: 0;
  width: 62.5px;
  height: 44px;
  line-height: 44px;
  background: #0084ff;
  z-index: 100;
  text-align: center;
  color: white;
  cursor: pointer;
}

.leftFocus {
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 44px;
  line-height: 44px;
  background: #0084ff;
  z-index: 100;
  text-align: center;
  color: white;
  cursor: pointer;
}

/* 关注 */
.weixincode .van-popup {
  padding: 0;
}

.popup-head {
  padding: 12px 10px;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.popup-head .pp-title-top {
  display: flex;
  border-bottom: 0;
  justify-content: center;
}

img {
  vertical-align: middle;
  border: none;
}

.popup .popup-head > div > img {
  width: 13px;
  height: 7px;
  align-self: center;
  margin: 0 9px;
}

.popup .popup-head > div > img {
  width: 13px;
  height: 7px;
  align-self: center;
  margin: 0 9px;
}

.popup-title {
  margin: 0;
  padding: 0;
  font-size: 15px;
}

.popup-body {
  padding: 10px 10px;
  text-align: center;
}

.live-way .van-button {
  width: 200px;
  margin-bottom: 10px;
  height: 34px;
  line-height: 34px;
}

.popup .popup-body {
  padding-bottom: 10px;
  padding-top: 10px;
}

.popup .popup-end {
  font-size: 15px;
  font-weight: 500;
  color: #747474;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #f0f0f0;
}

.teacherQr {
  position: absolute;
  top: 7px;
  right: 10px;
  width: 45px;
  height: 45px;
  z-index: 2002;
}

.loginWay {
  padding: 10%;
}
.loginWay .qqtitle {
  color: #000;
  font-size: 16px;
  text-align: center;
}
.loginWay .qqBox {
  display: block;
  font-size: 12px;
  color: #000;
  text-decoration: none;
  margin: 25px 8px 15px 8px;
  text-align: center;
}
.loginWay .qqlogoImg {
  display: block;
  width: 60px;
  height: 60px;
  margin: 0 auto 5px;
}

.qqLogin {
  z-index: 2002 !important;
}

.onlineSchoolLogin {
  z-index: 2003 !important;
}

.onlineSchoolLoginWay {
  height: 100vh;
  background: linear-gradient(0deg, #fff 70%, #78d4b6 100%);
}

.onlineSchoolLoginWay .title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  line-height: 33px;
  padding-top: 77px;
  margin-left: 7%;
}

.onlineSchoolLoginWay .desc {
  font-size: 14px;
  font-weight: 400;
  color: #888888;
  line-height: 20px;
  margin-top: 10px;
  margin-left: 7%;
}

.onlineSchoolLoginWay .loginContent .loginOnlineBtn {
  width: 100%;
  margin-left: 7%;
  width: 86%;
  height: 44px;
  margin-top: 46px;
  border-radius: 22px;
  background: linear-gradient(95deg, #78d4b6 4%, #0bb67e 95%);
  font-size: 15px;
}

.onlineSchoolLoginWay .loginContent .loginInput {
  border: none;
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  margin-left: 10px;
  flex: 1;
}
.onlineSchoolLoginWay .loginContent .passwordInput {
  padding-left: 8px;
}

.onlineSchoolLoginWay .loginContent .account {
  display: flex;
  margin-top: 20px;
  margin-bottom: 10px;
  height: 44px;
  line-height: 44px;
  margin-left: 7%;
  width: 86%;
  background-color: #f6f6f6;
  border-radius: 22px;
}

.onlineSchoolLoginWay .loginContent .account .area {
  font-size: 14px;
  font-weight: 550;
  color: #101010;
  line-height: 44px;
  margin-left: 16px;
}

.onlineSchoolLoginWay .loginContent .sendBtn {
  float: right;
}

.onlineSchoolLoginWay .loginContent .password {
  margin-top: 20px;
  margin-bottom: 10px;
  height: 44px;
  line-height: 44px;
  margin-left: 7%;
  width: 86%;
  background-color: #f6f6f6;
  border-radius: 22px;
}
.weixincode .van-popup {
  border-radius: 0px;
}
.onlineSchoolLoginWay .loginContent .password .van-button--primary {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  color: #10a675;
  font-size: 14px;
  margin-top: 7px;
  margin-right: 10px;
}
</style>

<style>
   .SPZBPlayer .controns{
      display: none !important;
   }
</style>